//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { OXOAPIClientBase } from './oxo.api.client.base';

export const Gateway_BASE_URL = new InjectionToken<string>('Gateway_BASE_URL');

@Injectable({
  providedIn: 'root',
})
export class FinAPIClient extends OXOAPIClientBase {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(Gateway_BASE_URL) baseUrl?: string) {
    super();
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param leafsOnly (optional)
   * @param includeManagedAccount (optional)
   * @param filterText (optional)
   * @return OK
   */
  getAccountsListCount(
    leafsOnly?: boolean | undefined,
    includeManagedAccount?: boolean | undefined,
    filterText?: string | undefined,
  ): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/GetAccountsListCount?';
    if (leafsOnly === null) throw new globalThis.Error("The parameter 'leafsOnly' cannot be null.");
    else if (leafsOnly !== undefined) url_ += 'leafsOnly=' + encodeURIComponent('' + leafsOnly) + '&';
    if (includeManagedAccount === null)
      throw new globalThis.Error("The parameter 'includeManagedAccount' cannot be null.");
    else if (includeManagedAccount !== undefined)
      url_ += 'IncludeManagedAccount=' + encodeURIComponent('' + includeManagedAccount) + '&';
    if (filterText === null) throw new globalThis.Error("The parameter 'filterText' cannot be null.");
    else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountsListCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountsListCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetAccountsListCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param leafsOnly (optional)
   * @param includeManagedAccount (optional)
   * @param selectedAccountID (optional)
   * @param filterText (optional)
   * @return OK
   */
  getAccountsList(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    leafsOnly?: boolean | undefined,
    includeManagedAccount?: boolean | undefined,
    selectedAccountID?: number | undefined,
    filterText?: string | undefined,
  ): Observable<FinancialTreeViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/GetAccountsList?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'pageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (leafsOnly === null) throw new globalThis.Error("The parameter 'leafsOnly' cannot be null.");
    else if (leafsOnly !== undefined) url_ += 'leafsOnly=' + encodeURIComponent('' + leafsOnly) + '&';
    if (includeManagedAccount === null)
      throw new globalThis.Error("The parameter 'includeManagedAccount' cannot be null.");
    else if (includeManagedAccount !== undefined)
      url_ += 'IncludeManagedAccount=' + encodeURIComponent('' + includeManagedAccount) + '&';
    if (selectedAccountID === null) throw new globalThis.Error("The parameter 'selectedAccountID' cannot be null.");
    else if (selectedAccountID !== undefined)
      url_ += 'selectedAccountID=' + encodeURIComponent('' + selectedAccountID) + '&';
    if (filterText === null) throw new globalThis.Error("The parameter 'filterText' cannot be null.");
    else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountsList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountsList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialTreeViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialTreeViewModel[]>;
        }),
      );
  }

  protected processGetAccountsList(response: HttpResponseBase): Observable<FinancialTreeViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialTreeViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param leafsOnly (optional)
   * @param includeManagedAccount (optional)
   * @return OK
   */
  getAllAccountsList(
    leafsOnly?: boolean | undefined,
    includeManagedAccount?: boolean | undefined,
  ): Observable<FinancialTreeViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/GetAllAccountsList?';
    if (leafsOnly === null) throw new globalThis.Error("The parameter 'leafsOnly' cannot be null.");
    else if (leafsOnly !== undefined) url_ += 'leafsOnly=' + encodeURIComponent('' + leafsOnly) + '&';
    if (includeManagedAccount === null)
      throw new globalThis.Error("The parameter 'includeManagedAccount' cannot be null.");
    else if (includeManagedAccount !== undefined)
      url_ += 'includeManagedAccount=' + encodeURIComponent('' + includeManagedAccount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllAccountsList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllAccountsList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialTreeViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialTreeViewModel[]>;
        }),
      );
  }

  protected processGetAllAccountsList(response: HttpResponseBase): Observable<FinancialTreeViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialTreeViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param currencyID (optional)
   * @return OK
   */
  getFinAccountDetailsByID(currencyID?: number | undefined): Observable<FinancialTreeViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/GetFinAccountDetailsByID?';
    if (currencyID === null) throw new globalThis.Error("The parameter 'currencyID' cannot be null.");
    else if (currencyID !== undefined) url_ += 'CurrencyID=' + encodeURIComponent('' + currencyID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinAccountDetailsByID(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinAccountDetailsByID(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialTreeViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialTreeViewModel>;
        }),
      );
  }

  protected processGetFinAccountDetailsByID(response: HttpResponseBase): Observable<FinancialTreeViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialTreeViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateFinaicialAccountCurrency(body?: AccountCurrencyViewModel | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/UpdateFinaicialAccountCurrency';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFinaicialAccountCurrency(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFinaicialAccountCurrency(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processUpdateFinaicialAccountCurrency(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param accountID (optional)
   * @param currencyID (optional)
   * @return OK
   */
  checkAccountCurrencyEditable(
    accountID?: number | undefined,
    currencyID?: number | undefined,
  ): Observable<BooleanSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/CheckAccountCurrencyEditable?';
    if (accountID === null) throw new globalThis.Error("The parameter 'accountID' cannot be null.");
    else if (accountID !== undefined) url_ += 'AccountID=' + encodeURIComponent('' + accountID) + '&';
    if (currencyID === null) throw new globalThis.Error("The parameter 'currencyID' cannot be null.");
    else if (currencyID !== undefined) url_ += 'CurrencyID=' + encodeURIComponent('' + currencyID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckAccountCurrencyEditable(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckAccountCurrencyEditable(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BooleanSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BooleanSystemResponse>;
        }),
      );
  }

  protected processCheckAccountCurrencyEditable(response: HttpResponseBase): Observable<BooleanSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BooleanSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param accountID (optional)
   * @return OK
   */
  checkAccountZeroDigit(accountID?: number | undefined): Observable<BooleanSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/CheckAccountZeroDigit?';
    if (accountID === null) throw new globalThis.Error("The parameter 'accountID' cannot be null.");
    else if (accountID !== undefined) url_ += 'AccountID=' + encodeURIComponent('' + accountID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckAccountZeroDigit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckAccountZeroDigit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BooleanSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BooleanSystemResponse>;
        }),
      );
  }

  protected processCheckAccountZeroDigit(response: HttpResponseBase): Observable<BooleanSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BooleanSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param parentAccountID (optional)
   * @return OK
   */
  addZeroDigitToFinParent(parentAccountID?: number | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/AddZeroDigitToFinParent?';
    if (parentAccountID === null) throw new globalThis.Error("The parameter 'parentAccountID' cannot be null.");
    else if (parentAccountID !== undefined) url_ += 'ParentAccountID=' + encodeURIComponent('' + parentAccountID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddZeroDigitToFinParent(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddZeroDigitToFinParent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processAddZeroDigitToFinParent(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  createFinaicialAccount(body?: FinancialTreeViewModel | undefined): Observable<FinancialTreeViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/CreateFinaicialAccount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFinaicialAccount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateFinaicialAccount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialTreeViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialTreeViewModelSystemResponse>;
        }),
      );
  }

  protected processCreateFinaicialAccount(
    response: HttpResponseBase,
  ): Observable<FinancialTreeViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialTreeViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateFinaicialAccount(body?: FinancialTreeViewModel | undefined): Observable<FinancialTreeViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/UpdateFinaicialAccount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFinaicialAccount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFinaicialAccount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialTreeViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialTreeViewModelSystemResponse>;
        }),
      );
  }

  protected processUpdateFinaicialAccount(
    response: HttpResponseBase,
  ): Observable<FinancialTreeViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialTreeViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param accountID (optional)
   * @return OK
   */
  deleteFinaicialAccount(accountID?: number | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/DeleteFinaicialAccount?';
    if (accountID === null) throw new globalThis.Error("The parameter 'accountID' cannot be null.");
    else if (accountID !== undefined) url_ += 'AccountID=' + encodeURIComponent('' + accountID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFinaicialAccount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteFinaicialAccount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processDeleteFinaicialAccount(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param accountID (optional)
   * @param newParentID (optional)
   * @return OK
   */
  updateFinAccountParent(
    accountID?: number | undefined,
    newParentID?: number | undefined,
  ): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/UpdateFinAccountParent?';
    if (accountID === null) throw new globalThis.Error("The parameter 'accountID' cannot be null.");
    else if (accountID !== undefined) url_ += 'AccountID=' + encodeURIComponent('' + accountID) + '&';
    if (newParentID === null) throw new globalThis.Error("The parameter 'newParentID' cannot be null.");
    else if (newParentID !== undefined) url_ += 'NewParentID=' + encodeURIComponent('' + newParentID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFinAccountParent(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFinAccountParent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processUpdateFinAccountParent(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  resetAccountsTree(): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/ResetAccountsTree';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetAccountsTree(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetAccountsTree(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processResetAccountsTree(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  createDefaultAccountsTree(): Observable<BooleanSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/CreateDefaultAccountsTree';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDefaultAccountsTree(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateDefaultAccountsTree(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BooleanSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BooleanSystemResponse>;
        }),
      );
  }

  protected processCreateDefaultAccountsTree(response: HttpResponseBase): Observable<BooleanSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BooleanSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param excelFile (optional)
   * @return OK
   */
  uploadAccountChartFile(excelFile?: FileParameter | undefined): Observable<SystemResponse_1OfList_1OfString> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/UploadAccountChartFile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (excelFile === null || excelFile === undefined)
      throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
    else content_.append('ExcelFile', excelFile.data, excelFile.fileName ? excelFile.fileName : 'ExcelFile');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadAccountChartFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadAccountChartFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfString>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfString>;
        }),
      );
  }

  protected processUploadAccountChartFile(response: HttpResponseBase): Observable<SystemResponse_1OfList_1OfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfString);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getAccountsTreeExcel(): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/GetAccountsTreeExcel';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountsTreeExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountsTreeExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetAccountsTreeExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param companyID (optional)
   * @param body (optional)
   * @return OK
   */
  migrateCompanyEquityAndExpensesCodes(
    companyID?: number | undefined,
    body?: number[] | undefined,
  ): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Account/MigrateCompanyEquityAndExpensesCodes?';
    if (companyID === null) throw new globalThis.Error("The parameter 'companyID' cannot be null.");
    else if (companyID !== undefined) url_ += 'companyID=' + encodeURIComponent('' + companyID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMigrateCompanyEquityAndExpensesCodes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMigrateCompanyEquityAndExpensesCodes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processMigrateCompanyEquityAndExpensesCodes(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getUnClosedFinaicialYears(): Observable<FinancialYearViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/AutomaticFinishing/GetUnClosedFinaicialYears';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUnClosedFinaicialYears(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUnClosedFinaicialYears(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialYearViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialYearViewModel[]>;
        }),
      );
  }

  protected processGetUnClosedFinaicialYears(response: HttpResponseBase): Observable<FinancialYearViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialYearViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param closingFinaicialYearID (optional)
   * @return OK
   */
  startFinishingFinYear(closingFinaicialYearID?: number | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/AutomaticFinishing/StartFinishingFinYear?';
    if (closingFinaicialYearID === null)
      throw new globalThis.Error("The parameter 'closingFinaicialYearID' cannot be null.");
    else if (closingFinaicialYearID !== undefined)
      url_ += 'ClosingFinaicialYearID=' + encodeURIComponent('' + closingFinaicialYearID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStartFinishingFinYear(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStartFinishingFinYear(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processStartFinishingFinYear(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param closingFinaicialYearID (optional)
   * @return OK
   */
  getUnconfirmedDailyRecordsCount(closingFinaicialYearID?: number | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/AutomaticFinishing/GetUnconfirmedDailyRecordsCount?';
    if (closingFinaicialYearID === null)
      throw new globalThis.Error("The parameter 'closingFinaicialYearID' cannot be null.");
    else if (closingFinaicialYearID !== undefined)
      url_ += 'ClosingFinaicialYearID=' + encodeURIComponent('' + closingFinaicialYearID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUnconfirmedDailyRecordsCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUnconfirmedDailyRecordsCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetUnconfirmedDailyRecordsCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param closingFinaicialYearID (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getUnconfirmedDailyRecords(
    closingFinaicialYearID?: number | undefined,
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
  ): Observable<DailyRecordViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/AutomaticFinishing/GetUnconfirmedDailyRecords?';
    if (closingFinaicialYearID === null)
      throw new globalThis.Error("The parameter 'closingFinaicialYearID' cannot be null.");
    else if (closingFinaicialYearID !== undefined)
      url_ += 'ClosingFinaicialYearID=' + encodeURIComponent('' + closingFinaicialYearID) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUnconfirmedDailyRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUnconfirmedDailyRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModel[]>;
        }),
      );
  }

  protected processGetUnconfirmedDailyRecords(response: HttpResponseBase): Observable<DailyRecordViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param closingFinaicialYearID (optional)
   * @return OK
   */
  getFinaicialYearBalance(closingFinaicialYearID?: number | undefined): Observable<DecimalSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/AutomaticFinishing/GetFinaicialYearBalance?';
    if (closingFinaicialYearID === null)
      throw new globalThis.Error("The parameter 'closingFinaicialYearID' cannot be null.");
    else if (closingFinaicialYearID !== undefined)
      url_ += 'ClosingFinaicialYearID=' + encodeURIComponent('' + closingFinaicialYearID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinaicialYearBalance(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinaicialYearBalance(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DecimalSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DecimalSystemResponse>;
        }),
      );
  }

  protected processGetFinaicialYearBalance(response: HttpResponseBase): Observable<DecimalSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DecimalSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param closingFinaicialYearID (optional)
   * @param newFinancilYearID (optional)
   * @param postByAccountAndCostCenter (optional)
   * @return OK
   */
  postFinaicialYearBalances(
    closingFinaicialYearID?: number | undefined,
    newFinancilYearID?: number | undefined,
    postByAccountAndCostCenter?: boolean | undefined,
  ): Observable<PostBalancesViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/AutomaticFinishing/PostFinaicialYearBalances?';
    if (closingFinaicialYearID === null)
      throw new globalThis.Error("The parameter 'closingFinaicialYearID' cannot be null.");
    else if (closingFinaicialYearID !== undefined)
      url_ += 'ClosingFinaicialYearID=' + encodeURIComponent('' + closingFinaicialYearID) + '&';
    if (newFinancilYearID === null) throw new globalThis.Error("The parameter 'newFinancilYearID' cannot be null.");
    else if (newFinancilYearID !== undefined)
      url_ += 'NewFinancilYearID=' + encodeURIComponent('' + newFinancilYearID) + '&';
    if (postByAccountAndCostCenter === null)
      throw new globalThis.Error("The parameter 'postByAccountAndCostCenter' cannot be null.");
    else if (postByAccountAndCostCenter !== undefined)
      url_ += 'postByAccountAndCostCenter=' + encodeURIComponent('' + postByAccountAndCostCenter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostFinaicialYearBalances(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostFinaicialYearBalances(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PostBalancesViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<PostBalancesViewModelSystemResponse>;
        }),
      );
  }

  protected processPostFinaicialYearBalances(
    response: HttpResponseBase,
  ): Observable<PostBalancesViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as PostBalancesViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @param isActive (optional)
   * @return OK
   */
  getCostCenterList(text?: string | undefined, isActive?: boolean | undefined): Observable<CostCenterViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/CostCenters/GetCostCenterList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    if (isActive === null) throw new globalThis.Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCostCenterList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCostCenterList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CostCenterViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CostCenterViewModel[]>;
        }),
      );
  }

  protected processGetCostCenterList(response: HttpResponseBase): Observable<CostCenterViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CostCenterViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @return OK
   */
  getAllCostCentersList(text?: string | undefined): Observable<CostCenterViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/CostCenters/GetAllCostCentersList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllCostCentersList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllCostCentersList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CostCenterViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CostCenterViewModel[]>;
        }),
      );
  }

  protected processGetAllCostCentersList(response: HttpResponseBase): Observable<CostCenterViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CostCenterViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getOpeningRecord(): Observable<DailyRecordDetailViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetOpeningRecord';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOpeningRecord(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOpeningRecord(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
        }),
      );
  }

  protected processGetOpeningRecord(response: HttpResponseBase): Observable<DailyRecordDetailViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordDetailViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  getFinRecord(id?: number | undefined): Observable<DailyRecordViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetFinRecord?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinRecord(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinRecord(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModelSystemResponse>;
        }),
      );
  }

  protected processGetFinRecord(response: HttpResponseBase): Observable<DailyRecordViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param recordID (optional)
   * @return OK
   */
  getFinRecordWithDetails(recordID?: number | undefined): Observable<DailyRecordDetailViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetFinRecordWithDetails?';
    if (recordID === null) throw new globalThis.Error("The parameter 'recordID' cannot be null.");
    else if (recordID !== undefined) url_ += 'recordID=' + encodeURIComponent('' + recordID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinRecordWithDetails(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinRecordWithDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
        }),
      );
  }

  protected processGetFinRecordWithDetails(
    response: HttpResponseBase,
  ): Observable<DailyRecordDetailViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordDetailViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param recordCode (optional)
   * @return OK
   */
  getFinRecordByCodeWithDetails(recordCode?: number | undefined): Observable<DailyRecordDetailViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetFinRecordByCodeWithDetails?';
    if (recordCode === null) throw new globalThis.Error("The parameter 'recordCode' cannot be null.");
    else if (recordCode !== undefined) url_ += 'recordCode=' + encodeURIComponent('' + recordCode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinRecordByCodeWithDetails(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinRecordByCodeWithDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
        }),
      );
  }

  protected processGetFinRecordByCodeWithDetails(
    response: HttpResponseBase,
  ): Observable<DailyRecordDetailViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordDetailViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  getFinRecordLines(id?: number | undefined): Observable<DebitCridetViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetFinRecordLines?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinRecordLines(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinRecordLines(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DebitCridetViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<DebitCridetViewModel[]>;
        }),
      );
  }

  protected processGetFinRecordLines(response: HttpResponseBase): Observable<DebitCridetViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DebitCridetViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  saveRecord(body?: DailyRecordDetailViewModelExt | undefined): Observable<DailyRecordDetailViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/SaveRecord';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveRecord(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveRecord(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordDetailViewModelSystemResponse>;
        }),
      );
  }

  protected processSaveRecord(response: HttpResponseBase): Observable<DailyRecordDetailViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordDetailViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getCurrentFinancilYearData(): Observable<FinancialYearViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetCurrentFinancilYearData';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentFinancilYearData(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentFinancilYearData(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialYearViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialYearViewModel>;
        }),
      );
  }

  protected processGetCurrentFinancilYearData(response: HttpResponseBase): Observable<FinancialYearViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialYearViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param parentCostCenterID (optional)
   * @return OK
   */
  getDefaultAuthorizedCostCenter(parentCostCenterID?: number | undefined): Observable<CostCenterViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetDefaultAuthorizedCostCenter?';
    if (parentCostCenterID === null) throw new globalThis.Error("The parameter 'parentCostCenterID' cannot be null.");
    else if (parentCostCenterID !== undefined)
      url_ += 'ParentCostCenterID=' + encodeURIComponent('' + parentCostCenterID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDefaultAuthorizedCostCenter(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDefaultAuthorizedCostCenter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CostCenterViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CostCenterViewModel>;
        }),
      );
  }

  protected processGetDefaultAuthorizedCostCenter(response: HttpResponseBase): Observable<CostCenterViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CostCenterViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param recordID (optional)
   * @return OK
   */
  getRecordReportPDF(recordID?: number | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetRecordReportPDF?';
    if (recordID === null) throw new globalThis.Error("The parameter 'recordID' cannot be null.");
    else if (recordID !== undefined) url_ += 'RecordID=' + encodeURIComponent('' + recordID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRecordReportPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRecordReportPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetRecordReportPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param costCenterID (optional)
   * @param title (optional)
   * @param excelFile (optional)
   * @return OK
   */
  importDailyRecordDetails(
    costCenterID?: number | undefined,
    title?: string | undefined,
    excelFile?: FileParameter | undefined,
  ): Observable<SystemResponse_1OfList_1OfDebitCridetViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/ImportDailyRecordDetails?';
    if (costCenterID === null) throw new globalThis.Error("The parameter 'costCenterID' cannot be null.");
    else if (costCenterID !== undefined) url_ += 'CostCenterID=' + encodeURIComponent('' + costCenterID) + '&';
    if (title === null) throw new globalThis.Error("The parameter 'title' cannot be null.");
    else if (title !== undefined) url_ += 'Title=' + encodeURIComponent('' + title) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (excelFile === null || excelFile === undefined)
      throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
    else content_.append('ExcelFile', excelFile.data, excelFile.fileName ? excelFile.fileName : 'ExcelFile');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImportDailyRecordDetails(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImportDailyRecordDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfDebitCridetViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfDebitCridetViewModel>;
        }),
      );
  }

  protected processImportDailyRecordDetails(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfList_1OfDebitCridetViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfDebitCridetViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param code (optional)
   * @param taxVendorID (optional)
   * @return OK
   */
  checkBillNoForExpenseRecord(
    code?: string | undefined,
    taxVendorID?: number | undefined,
  ): Observable<BooleanSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/CheckBillNoForExpenseRecord?';
    if (code === null) throw new globalThis.Error("The parameter 'code' cannot be null.");
    else if (code !== undefined) url_ += 'Code=' + encodeURIComponent('' + code) + '&';
    if (taxVendorID === null) throw new globalThis.Error("The parameter 'taxVendorID' cannot be null.");
    else if (taxVendorID !== undefined) url_ += 'TaxVendorID=' + encodeURIComponent('' + taxVendorID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckBillNoForExpenseRecord(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckBillNoForExpenseRecord(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BooleanSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BooleanSystemResponse>;
        }),
      );
  }

  protected processCheckBillNoForExpenseRecord(response: HttpResponseBase): Observable<BooleanSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BooleanSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param amount (optional)
   * @param taxPercent (optional)
   * @param title (optional)
   * @param fromAccountID (optional)
   * @param toAccountID (optional)
   * @param costCenterID (optional)
   * @param taxVendorID (optional)
   * @param bill_No (optional)
   * @return OK
   */
  prepareNewExpensesRecordLines(
    amount?: number | undefined,
    taxPercent?: number | undefined,
    title?: string | undefined,
    fromAccountID?: number | undefined,
    toAccountID?: number | undefined,
    costCenterID?: number | undefined,
    taxVendorID?: number | undefined,
    bill_No?: string | undefined,
  ): Observable<DebitCridetViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/PrepareNewExpensesRecordLines?';
    if (amount === null) throw new globalThis.Error("The parameter 'amount' cannot be null.");
    else if (amount !== undefined) url_ += 'Amount=' + encodeURIComponent('' + amount) + '&';
    if (taxPercent === null) throw new globalThis.Error("The parameter 'taxPercent' cannot be null.");
    else if (taxPercent !== undefined) url_ += 'TaxPercent=' + encodeURIComponent('' + taxPercent) + '&';
    if (title === null) throw new globalThis.Error("The parameter 'title' cannot be null.");
    else if (title !== undefined) url_ += 'Title=' + encodeURIComponent('' + title) + '&';
    if (fromAccountID === null) throw new globalThis.Error("The parameter 'fromAccountID' cannot be null.");
    else if (fromAccountID !== undefined) url_ += 'FromAccountID=' + encodeURIComponent('' + fromAccountID) + '&';
    if (toAccountID === null) throw new globalThis.Error("The parameter 'toAccountID' cannot be null.");
    else if (toAccountID !== undefined) url_ += 'ToAccountID=' + encodeURIComponent('' + toAccountID) + '&';
    if (costCenterID === null) throw new globalThis.Error("The parameter 'costCenterID' cannot be null.");
    else if (costCenterID !== undefined) url_ += 'CostCenterID=' + encodeURIComponent('' + costCenterID) + '&';
    if (taxVendorID === null) throw new globalThis.Error("The parameter 'taxVendorID' cannot be null.");
    else if (taxVendorID !== undefined) url_ += 'TaxVendorID=' + encodeURIComponent('' + taxVendorID) + '&';
    if (bill_No === null) throw new globalThis.Error("The parameter 'bill_No' cannot be null.");
    else if (bill_No !== undefined) url_ += 'Bill_No=' + encodeURIComponent('' + bill_No) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPrepareNewExpensesRecordLines(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPrepareNewExpensesRecordLines(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DebitCridetViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<DebitCridetViewModel[]>;
        }),
      );
  }

  protected processPrepareNewExpensesRecordLines(response: HttpResponseBase): Observable<DebitCridetViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DebitCridetViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getAllDailyRecordsCount(body?: AccountRecordSearchCratiria | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetAllDailyRecordsCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllDailyRecordsCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllDailyRecordsCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetAllDailyRecordsCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getAllDailyRecords(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: AccountRecordSearchCratiria | undefined,
  ): Observable<DailyRecordViewModelListSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetAllDailyRecords?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'pageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllDailyRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllDailyRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModelListSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModelListSystemResponse>;
        }),
      );
  }

  protected processGetAllDailyRecords(response: HttpResponseBase): Observable<DailyRecordViewModelListSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModelListSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getAllDailyRecordsExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetAllDailyRecordsExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllDailyRecordsExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllDailyRecordsExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetAllDailyRecordsExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getAllDailyRecordsPDF(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetAllDailyRecordsPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllDailyRecordsPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllDailyRecordsPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetAllDailyRecordsPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotValidRecordsCount(body?: AccountRecordSearchCratiria | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotValidRecordsCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotValidRecordsCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotValidRecordsCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetNotValidRecordsCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getNotValidRecords(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: AccountRecordSearchCratiria | undefined,
  ): Observable<DailyRecordViewModelListSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotValidRecords?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'pageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotValidRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotValidRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModelListSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModelListSystemResponse>;
        }),
      );
  }

  protected processGetNotValidRecords(response: HttpResponseBase): Observable<DailyRecordViewModelListSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModelListSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotApprovedRecordsCount(body?: AccountRecordSearchCratiria | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotApprovedRecordsCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotApprovedRecordsCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotApprovedRecordsCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetNotApprovedRecordsCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getNotApprovedRecords(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: AccountRecordSearchCratiria | undefined,
  ): Observable<DailyRecordViewModelListSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotApprovedRecords?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'pageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotApprovedRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotApprovedRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModelListSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModelListSystemResponse>;
        }),
      );
  }

  protected processGetNotApprovedRecords(
    response: HttpResponseBase,
  ): Observable<DailyRecordViewModelListSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModelListSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  approveRecords(body?: number[] | undefined): Observable<BooleanSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/ApproveRecords';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApproveRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApproveRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BooleanSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BooleanSystemResponse>;
        }),
      );
  }

  protected processApproveRecords(response: HttpResponseBase): Observable<BooleanSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BooleanSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotApprovedRecordsExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotApprovedRecordsExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotApprovedRecordsExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotApprovedRecordsExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetNotApprovedRecordsExcel(
    response: HttpResponseBase,
  ): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotApprovedRecordsPDF(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotApprovedRecordsPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotApprovedRecordsPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotApprovedRecordsPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetNotApprovedRecordsPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotPostedRecordsCount(body?: AccountRecordSearchCratiria | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotPostedRecordsCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotPostedRecordsCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotPostedRecordsCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetNotPostedRecordsCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getNotPostedRecords(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: AccountRecordSearchCratiria | undefined,
  ): Observable<DailyRecordViewModelListSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotPostedRecords?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'pageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotPostedRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotPostedRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModelListSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModelListSystemResponse>;
        }),
      );
  }

  protected processGetNotPostedRecords(response: HttpResponseBase): Observable<DailyRecordViewModelListSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModelListSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  postRecords(body?: number[] | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/PostRecords';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPostRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPostRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processPostRecords(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotPostedRecordsExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotPostedRecordsExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotPostedRecordsExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotPostedRecordsExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetNotPostedRecordsExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getNotPostedRecordsPDF(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetNotPostedRecordsPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotPostedRecordsPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotPostedRecordsPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetNotPostedRecordsPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getGeneralCounters(): Observable<FinCountersViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetGeneralCounters';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralCounters(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralCounters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinCountersViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FinCountersViewModel>;
        }),
      );
  }

  protected processGetGeneralCounters(response: HttpResponseBase): Observable<FinCountersViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FinCountersViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  costCentersRecordsCount(): Observable<FinCountersViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/CostCentersRecordsCount';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCostCentersRecordsCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCostCentersRecordsCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinCountersViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinCountersViewModel[]>;
        }),
      );
  }

  protected processCostCentersRecordsCount(response: HttpResponseBase): Observable<FinCountersViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FinCountersViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getLatestFinRecords(): Observable<DailyRecordViewModel2[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetLatestFinRecords';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLatestFinRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLatestFinRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyRecordViewModel2[]>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyRecordViewModel2[]>;
        }),
      );
  }

  protected processGetLatestFinRecords(response: HttpResponseBase): Observable<DailyRecordViewModel2[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DailyRecordViewModel2[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param startDate (optional)
   * @param endDate (optional)
   * @return OK
   */
  getRecordsByTypes(
    startDate?: Date | undefined,
    endDate?: Date | undefined,
  ): Observable<DailyFinRecordByTypeViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetRecordsByTypes?';
    if (startDate === null) throw new globalThis.Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (endDate === null) throw new globalThis.Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRecordsByTypes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRecordsByTypes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DailyFinRecordByTypeViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<DailyFinRecordByTypeViewModel[]>;
        }),
      );
  }

  protected processGetRecordsByTypes(response: HttpResponseBase): Observable<DailyFinRecordByTypeViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DailyFinRecordByTypeViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param recordID (optional)
   * @return OK
   */
  getDailyRecordAttachments(recordID?: number | undefined): Observable<ArchiveMapViewMode[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetDailyRecordAttachments?';
    if (recordID === null) throw new globalThis.Error("The parameter 'recordID' cannot be null.");
    else if (recordID !== undefined) url_ += 'RecordID=' + encodeURIComponent('' + recordID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDailyRecordAttachments(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDailyRecordAttachments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ArchiveMapViewMode[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ArchiveMapViewMode[]>;
        }),
      );
  }

  protected processGetDailyRecordAttachments(response: HttpResponseBase): Observable<ArchiveMapViewMode[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ArchiveMapViewMode[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param referenceID (optional)
   * @param archiveTypeID (optional)
   * @param notes (optional)
   * @param file (optional)
   * @return OK
   */
  uploadDailyRecordAttachment(
    referenceID?: number | undefined,
    archiveTypeID?: number | undefined,
    notes?: string | undefined,
    file?: FileParameter | undefined,
  ): Observable<SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/UploadDailyRecordAttachment?';
    if (referenceID === null) throw new globalThis.Error("The parameter 'referenceID' cannot be null.");
    else if (referenceID !== undefined) url_ += 'ReferenceID=' + encodeURIComponent('' + referenceID) + '&';
    if (archiveTypeID === null) throw new globalThis.Error("The parameter 'archiveTypeID' cannot be null.");
    else if (archiveTypeID !== undefined) url_ += 'ArchiveTypeID=' + encodeURIComponent('' + archiveTypeID) + '&';
    if (notes === null) throw new globalThis.Error("The parameter 'notes' cannot be null.");
    else if (notes !== undefined) url_ += 'Notes=' + encodeURIComponent('' + notes) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new globalThis.Error("The parameter 'file' cannot be null.");
    else content_.append('File', file.data, file.fileName ? file.fileName : 'File');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadDailyRecordAttachment(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadDailyRecordAttachment(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse>;
        }),
      );
  }

  protected processUploadDailyRecordAttachment(response: HttpResponseBase): Observable<SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param archiveMapID (optional)
   * @return OK
   */
  deleteDailyRecordAttachment(archiveMapID?: number | undefined): Observable<SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/DeleteDailyRecordAttachment?';
    if (archiveMapID === null) throw new globalThis.Error("The parameter 'archiveMapID' cannot be null.");
    else if (archiveMapID !== undefined) url_ += 'ArchiveMapID=' + encodeURIComponent('' + archiveMapID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteDailyRecordAttachment(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteDailyRecordAttachment(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse>;
        }),
      );
  }

  protected processDeleteDailyRecordAttachment(response: HttpResponseBase): Observable<SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param archiveMapID (optional)
   * @return OK
   */
  downloadFile(archiveMapID?: number | undefined): Observable<DownloadFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/DownloadFile?';
    if (archiveMapID === null) throw new globalThis.Error("The parameter 'archiveMapID' cannot be null.");
    else if (archiveMapID !== undefined) url_ += 'ArchiveMapID=' + encodeURIComponent('' + archiveMapID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DownloadFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DownloadFileViewModelSystemResponse>;
        }),
      );
  }

  protected processDownloadFile(response: HttpResponseBase): Observable<DownloadFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param costCenterID (optional)
   * @param excelFile (optional)
   * @return OK
   */
  importRecords(
    costCenterID?: number | undefined,
    excelFile?: FileParameter | undefined,
  ): Observable<SystemResponse_1OfList_1OfString> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/ImportRecords?';
    if (costCenterID === null) throw new globalThis.Error("The parameter 'costCenterID' cannot be null.");
    else if (costCenterID !== undefined) url_ += 'CostCenterID=' + encodeURIComponent('' + costCenterID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (excelFile === null || excelFile === undefined)
      throw new globalThis.Error("The parameter 'excelFile' cannot be null.");
    else content_.append('ExcelFile', excelFile.data, excelFile.fileName ? excelFile.fileName : 'ExcelFile');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImportRecords(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImportRecords(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfString>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfString>;
        }),
      );
  }

  protected processImportRecords(response: HttpResponseBase): Observable<SystemResponse_1OfList_1OfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfString);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param filterText (optional)
   * @return OK
   */
  getTaxVendors(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    filterText?: string | undefined,
  ): Observable<TaxVendorViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/GetTaxVendors?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (filterText === null) throw new globalThis.Error("The parameter 'filterText' cannot be null.");
    else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTaxVendors(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTaxVendors(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TaxVendorViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<TaxVendorViewModel[]>;
        }),
      );
  }

  protected processGetTaxVendors(response: HttpResponseBase): Observable<TaxVendorViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TaxVendorViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  addNewTaxVendor(body?: TaxVendorViewModel | undefined): Observable<TaxVendorViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/DailyRecord/AddNewTaxVendor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddNewTaxVendor(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddNewTaxVendor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TaxVendorViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TaxVendorViewModelSystemResponse>;
        }),
      );
  }

  protected processAddNewTaxVendor(response: HttpResponseBase): Observable<TaxVendorViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as TaxVendorViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getFinancialYears(): Observable<FinancialYearViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/FinancialYear/GetFinancialYears';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinancialYears(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinancialYears(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialYearViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialYearViewModel[]>;
        }),
      );
  }

  protected processGetFinancialYears(response: HttpResponseBase): Observable<FinancialYearViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialYearViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getUnClosedFinancialYears(): Observable<FinancialYearViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/FinancialYear/GetUnClosedFinancialYears';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUnClosedFinancialYears(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUnClosedFinancialYears(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialYearViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialYearViewModel[]>;
        }),
      );
  }

  protected processGetUnClosedFinancialYears(response: HttpResponseBase): Observable<FinancialYearViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialYearViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  createNewFinancialYear(body?: FinancialYearViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/FinancialYear/CreateNewFinancialYear';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateNewFinancialYear(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateNewFinancialYear(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processCreateNewFinancialYear(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateFinancialYear(body?: FinancialYearViewModel | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/FinancialYear/UpdateFinancialYear';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFinancialYear(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFinancialYear(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processUpdateFinancialYear(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @return OK
   */
  getPOSList(text?: string | undefined): Observable<BranchData[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetPOSList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPOSList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPOSList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BranchData[]>;
            }
          } else return _observableThrow(response_) as any as Observable<BranchData[]>;
        }),
      );
  }

  protected processGetPOSList(response: HttpResponseBase): Observable<BranchData[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BranchData[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @return OK
   */
  getWarehouseList(text?: string | undefined): Observable<BranchData[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetWarehouseList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWarehouseList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWarehouseList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BranchData[]>;
            }
          } else return _observableThrow(response_) as any as Observable<BranchData[]>;
        }),
      );
  }

  protected processGetWarehouseList(response: HttpResponseBase): Observable<BranchData[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as BranchData[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @return OK
   */
  getCountriesList(text?: string | undefined): Observable<CountryData[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetCountriesList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCountriesList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCountriesList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryData[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryData[]>;
        }),
      );
  }

  protected processGetCountriesList(response: HttpResponseBase): Observable<CountryData[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CountryData[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @param countryID (optional)
   * @return OK
   */
  getCitiesList(text?: string | undefined, countryID?: number | undefined): Observable<CityData[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetCitiesList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    if (countryID === null) throw new globalThis.Error("The parameter 'countryID' cannot be null.");
    else if (countryID !== undefined) url_ += 'CountryID=' + encodeURIComponent('' + countryID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCitiesList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCitiesList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityData[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CityData[]>;
        }),
      );
  }

  protected processGetCitiesList(response: HttpResponseBase): Observable<CityData[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CityData[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @return OK
   */
  getFinancialYearStatus(text?: string | undefined): Observable<FinancialYearStatusViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetFinancialYearStatus?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinancialYearStatus(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinancialYearStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinancialYearStatusViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinancialYearStatusViewModel[]>;
        }),
      );
  }

  protected processGetFinancialYearStatus(response: HttpResponseBase): Observable<FinancialYearStatusViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinancialYearStatusViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getPaymentTypes(): Observable<PaymentTypeViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetPaymentTypes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPaymentTypes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPaymentTypes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PaymentTypeViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PaymentTypeViewModel[]>;
        }),
      );
  }

  protected processGetPaymentTypes(response: HttpResponseBase): Observable<PaymentTypeViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PaymentTypeViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param text (optional)
   * @return OK
   */
  getCurrenciesList(text?: string | undefined): Observable<CurrencyViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetCurrenciesList?';
    if (text === null) throw new globalThis.Error("The parameter 'text' cannot be null.");
    else if (text !== undefined) url_ += 'text=' + encodeURIComponent('' + text) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrenciesList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrenciesList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CurrencyViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CurrencyViewModel[]>;
        }),
      );
  }

  protected processGetCurrenciesList(response: HttpResponseBase): Observable<CurrencyViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CurrencyViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getDefaultCurrency(): Observable<CurrencyViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetDefaultCurrency';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDefaultCurrency(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDefaultCurrency(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CurrencyViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CurrencyViewModel>;
        }),
      );
  }

  protected processGetDefaultCurrency(response: HttpResponseBase): Observable<CurrencyViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CurrencyViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getArchiveTypes(): Observable<ArchivingTypeViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetArchiveTypes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetArchiveTypes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetArchiveTypes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ArchivingTypeViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ArchivingTypeViewModel[]>;
        }),
      );
  }

  protected processGetArchiveTypes(response: HttpResponseBase): Observable<ArchivingTypeViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ArchivingTypeViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getMonths(): Observable<MonthViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetMonths';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMonths(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMonths(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MonthViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<MonthViewModel[]>;
        }),
      );
  }

  protected processGetMonths(response: HttpResponseBase): Observable<MonthViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MonthViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getFinRecordTypesList(): Observable<FinRecordTypeViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/LookUp/GetFinRecordTypesList';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinRecordTypesList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinRecordTypesList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinRecordTypeViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FinRecordTypeViewModel[]>;
        }),
      );
  }

  protected processGetFinRecordTypesList(response: HttpResponseBase): Observable<FinRecordTypeViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinRecordTypeViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pOSID (optional)
   * @return OK
   */
  getPOSFinAccounts(pOSID?: number | undefined): Observable<POSPaymentTypeAccountViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/POSAccount/GetPOSFinAccounts?';
    if (pOSID === null) throw new globalThis.Error("The parameter 'pOSID' cannot be null.");
    else if (pOSID !== undefined) url_ += 'POSID=' + encodeURIComponent('' + pOSID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPOSFinAccounts(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPOSFinAccounts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<POSPaymentTypeAccountViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<POSPaymentTypeAccountViewModel[]>;
        }),
      );
  }

  protected processGetPOSFinAccounts(response: HttpResponseBase): Observable<POSPaymentTypeAccountViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as POSPaymentTypeAccountViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  editPOSFinAccounts(body?: POSPaymentTypeAccountViewModel | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/POSAccount/EditPOSFinAccounts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEditPOSFinAccounts(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEditPOSFinAccounts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processEditPOSFinAccounts(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getRelatedAccountsList(): Observable<RealtedAccountViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/RelatedAccount/GetRelatedAccountsList';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRelatedAccountsList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRelatedAccountsList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RealtedAccountViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RealtedAccountViewModel[]>;
        }),
      );
  }

  protected processGetRelatedAccountsList(response: HttpResponseBase): Observable<RealtedAccountViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RealtedAccountViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getRelatedAccountsListGrouped(): Observable<RelatedAccountGroupResultViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/RelatedAccount/GetRelatedAccountsListGrouped';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRelatedAccountsListGrouped(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRelatedAccountsListGrouped(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RelatedAccountGroupResultViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RelatedAccountGroupResultViewModel[]>;
        }),
      );
  }

  protected processGetRelatedAccountsListGrouped(
    response: HttpResponseBase,
  ): Observable<RelatedAccountGroupResultViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RelatedAccountGroupResultViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateRelatedAccount(body?: RealtedAccountViewModel | undefined): Observable<SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/RelatedAccount/UpdateRelatedAccount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateRelatedAccount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateRelatedAccount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse2>;
        }),
      );
  }

  protected processUpdateRelatedAccount(response: HttpResponseBase): Observable<SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getAccountStatement(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfList_1OfAccountStatementViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetAccountStatement';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountStatement(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountStatement(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfAccountStatementViewModel>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<SystemResponse_1OfList_1OfAccountStatementViewModel>;
        }),
      );
  }

  protected processGetAccountStatement(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfList_1OfAccountStatementViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver,
                ) as SystemResponse_1OfList_1OfAccountStatementViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getAccountStatementPDF(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfReportFileViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetAccountStatementPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountStatementPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountStatementPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfReportFileViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfReportFileViewModel>;
        }),
      );
  }

  protected processGetAccountStatementPDF(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfReportFileViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfReportFileViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getAccountStatementExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfReportFileViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetAccountStatementExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountStatementExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAccountStatementExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfReportFileViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfReportFileViewModel>;
        }),
      );
  }

  protected processGetAccountStatementExcel(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfReportFileViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfReportFileViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getGeneralLedger(): Observable<GeneralLedgerViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralLedger';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralLedger(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralLedger(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GeneralLedgerViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<GeneralLedgerViewModel[]>;
        }),
      );
  }

  protected processGetGeneralLedger(response: HttpResponseBase): Observable<GeneralLedgerViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GeneralLedgerViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getGeneralLedgerExcel(): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralLedgerExcel';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralLedgerExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralLedgerExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetGeneralLedgerExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getIncomeStatment(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<IncomeStatmentViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetIncomeStatment';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncomeStatment(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncomeStatment(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IncomeStatmentViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<IncomeStatmentViewModelSystemResponse>;
        }),
      );
  }

  protected processGetIncomeStatment(response: HttpResponseBase): Observable<IncomeStatmentViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IncomeStatmentViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getIncomeStatmentPDF(body?: AccountRecordSearchCratiria2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetIncomeStatmentPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncomeStatmentPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncomeStatmentPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetIncomeStatmentPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getIncomeStatmentExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetIncomeStatmentExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIncomeStatmentExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIncomeStatmentExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetIncomeStatmentExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getGeneralBudget(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfGeneralBudgetReportViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralBudget';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralBudget(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralBudget(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfGeneralBudgetReportViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<SystemResponse_1OfGeneralBudgetReportViewModel>;
        }),
      );
  }

  protected processGetGeneralBudget(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfGeneralBudgetReportViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfGeneralBudgetReportViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getGeneralBudgetPDF(body?: AccountRecordSearchCratiria2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralBudgetPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralBudgetPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralBudgetPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetGeneralBudgetPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getGeneralBudgetExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralBudgetExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralBudgetExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralBudgetExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetGeneralBudgetExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getBalanceSheet(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfGeneralBudgetReportViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetBalanceSheet';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBalanceSheet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBalanceSheet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfGeneralBudgetReportViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<SystemResponse_1OfGeneralBudgetReportViewModel>;
        }),
      );
  }

  protected processGetBalanceSheet(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfGeneralBudgetReportViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfGeneralBudgetReportViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getBalanceSheetPDF(body?: AccountRecordSearchCratiria2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetBalanceSheetPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBalanceSheetPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBalanceSheetPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetBalanceSheetPDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getBalanceSheetExcel(body?: AccountRecordSearchCratiria2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetBalanceSheetExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBalanceSheetExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBalanceSheetExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetBalanceSheetExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param costCenterID (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param showZeros (optional)
   * @return OK
   */
  getCashFlow(
    costCenterID?: number | undefined,
    startDate?: Date | undefined,
    endDate?: Date | undefined,
    showZeros?: boolean | undefined,
  ): Observable<GeneralBudgetViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetCashFlow?';
    if (costCenterID === null) throw new globalThis.Error("The parameter 'costCenterID' cannot be null.");
    else if (costCenterID !== undefined) url_ += 'CostCenterID=' + encodeURIComponent('' + costCenterID) + '&';
    if (startDate === null) throw new globalThis.Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (endDate === null) throw new globalThis.Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    if (showZeros === null) throw new globalThis.Error("The parameter 'showZeros' cannot be null.");
    else if (showZeros !== undefined) url_ += 'ShowZeros=' + encodeURIComponent('' + showZeros) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCashFlow(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCashFlow(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GeneralBudgetViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<GeneralBudgetViewModel[]>;
        }),
      );
  }

  protected processGetCashFlow(response: HttpResponseBase): Observable<GeneralBudgetViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GeneralBudgetViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getTrialBalance(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfList_1OfTrailBalanceViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetTrialBalance';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTrialBalance(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTrialBalance(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfTrailBalanceViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfTrailBalanceViewModel>;
        }),
      );
  }

  protected processGetTrialBalance(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfList_1OfTrailBalanceViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfTrailBalanceViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getTrialBalancePDF(body?: AccountRecordSearchCratiria2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetTrialBalancePDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTrialBalancePDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTrialBalancePDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetTrialBalancePDF(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getTrialBalanceExcel(body?: AccountRecordSearchCratiria2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetTrialBalanceExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTrialBalanceExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTrialBalanceExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetTrialBalanceExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getGeneralJournal(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<SystemResponse_1OfList_1OfDebitCridetViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralJournal?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralJournal(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralJournal(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfDebitCridetViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfDebitCridetViewModel>;
        }),
      );
  }

  protected processGetGeneralJournal(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfList_1OfDebitCridetViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfDebitCridetViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getGeneralJournalCount(body?: AccountRecordSearchCratiria2 | undefined): Observable<Int32SystemResponse2> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralJournalCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralJournalCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralJournalCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse2>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse2>;
        }),
      );
  }

  protected processGetGeneralJournalCount(response: HttpResponseBase): Observable<Int32SystemResponse2> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse2);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getGeneralJournalExcel(
    body?: AccountRecordSearchCratiria2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetGeneralJournalExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGeneralJournalExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGeneralJournalExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetGeneralJournalExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATReport(body?: TaxSearchViewModel | undefined): Observable<SystemResponse_1OfVATViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATReport';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATReport(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATReport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfVATViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfVATViewModel>;
        }),
      );
  }

  protected processGetVATReport(response: HttpResponseBase): Observable<SystemResponse_1OfVATViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfVATViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATReportExcel(body?: TaxSearchViewModel | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATReportExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATReportExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATReportExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVATReportExcel(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVATExpensesReport(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: TaxSearchViewModel | undefined,
  ): Observable<SystemResponse_1OfList_1OfDebitCridetViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATExpensesReport?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATExpensesReport(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATExpensesReport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfDebitCridetViewModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfDebitCridetViewModel>;
        }),
      );
  }

  protected processGetVATExpensesReport(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfList_1OfDebitCridetViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfDebitCridetViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATExpensesReportTotals(
    body?: TaxSearchViewModel | undefined,
  ): Observable<SystemResponse_1OfExpensesTotalsViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATExpensesReportTotals';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATExpensesReportTotals(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATExpensesReportTotals(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfExpensesTotalsViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfExpensesTotalsViewModel>;
        }),
      );
  }

  protected processGetVATExpensesReportTotals(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfExpensesTotalsViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfExpensesTotalsViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATExpensesReportExcel(body?: TaxSearchViewModel | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATExpensesReportExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATExpensesReportExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATExpensesReportExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVATExpensesReportExcel(
    response: HttpResponseBase,
  ): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVATSales(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: TaxSearchViewModel | undefined,
  ): Observable<OrderBaseViewModelListAPIResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATSales?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATSales(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATSales(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrderBaseViewModelListAPIResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<OrderBaseViewModelListAPIResponse>;
        }),
      );
  }

  protected processGetVATSales(response: HttpResponseBase): Observable<OrderBaseViewModelListAPIResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OrderBaseViewModelListAPIResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATSalesTotals(body?: TaxSearchViewModel | undefined): Observable<OrderTotalsViewModelAPIResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATSalesTotals';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATSalesTotals(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATSalesTotals(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrderTotalsViewModelAPIResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<OrderTotalsViewModelAPIResponse>;
        }),
      );
  }

  protected processGetVATSalesTotals(response: HttpResponseBase): Observable<OrderTotalsViewModelAPIResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OrderTotalsViewModelAPIResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATSalesExcel(body?: TaxSearchViewModel | undefined): Observable<SystemResponse_1OfReportFileViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATSalesExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATSalesExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATSalesExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfReportFileViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfReportFileViewModel>;
        }),
      );
  }

  protected processGetVATSalesExcel(response: HttpResponseBase): Observable<SystemResponse_1OfReportFileViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfReportFileViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVATReturns(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: TaxSearchViewModel | undefined,
  ): Observable<OrderReturnViewModelListAPIResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATReturns?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATReturns(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATReturns(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrderReturnViewModelListAPIResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<OrderReturnViewModelListAPIResponse>;
        }),
      );
  }

  protected processGetVATReturns(response: HttpResponseBase): Observable<OrderReturnViewModelListAPIResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OrderReturnViewModelListAPIResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATReturnsTotals(body?: TaxSearchViewModel | undefined): Observable<OrderTotalsViewModelAPIResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATReturnsTotals';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATReturnsTotals(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATReturnsTotals(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrderTotalsViewModelAPIResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<OrderTotalsViewModelAPIResponse>;
        }),
      );
  }

  protected processGetVATReturnsTotals(response: HttpResponseBase): Observable<OrderTotalsViewModelAPIResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OrderTotalsViewModelAPIResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATReturnsExcel(body?: TaxSearchViewModel | undefined): Observable<SystemResponse_1OfReportFileViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATReturnsExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATReturnsExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATReturnsExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfReportFileViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfReportFileViewModel>;
        }),
      );
  }

  protected processGetVATReturnsExcel(response: HttpResponseBase): Observable<SystemResponse_1OfReportFileViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfReportFileViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVATPurchases(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: TaxSearchViewModel | undefined,
  ): Observable<SystemResponse_1OfList_1OfStockViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATPurchases?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATPurchases(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATPurchases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfStockViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfStockViewModel>;
        }),
      );
  }

  protected processGetVATPurchases(response: HttpResponseBase): Observable<SystemResponse_1OfList_1OfStockViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfStockViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATPurchasesTotals(body?: TaxSearchViewModel | undefined): Observable<StockTotalsViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATPurchasesTotals';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATPurchasesTotals(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATPurchasesTotals(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StockTotalsViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<StockTotalsViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVATPurchasesTotals(response: HttpResponseBase): Observable<StockTotalsViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as StockTotalsViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATPurchasesExcel(body?: TaxSearchViewModel | undefined): Observable<SystemResponse_1OfReportFileViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATPurchasesExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATPurchasesExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATPurchasesExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfReportFileViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfReportFileViewModel>;
        }),
      );
  }

  protected processGetVATPurchasesExcel(response: HttpResponseBase): Observable<SystemResponse_1OfReportFileViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfReportFileViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVATPurchasesReturn(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: TaxSearchViewModel | undefined,
  ): Observable<SystemResponse_1OfList_1OfStockViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATPurchasesReturn?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATPurchasesReturn(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATPurchasesReturn(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfList_1OfStockViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfList_1OfStockViewModel>;
        }),
      );
  }

  protected processGetVATPurchasesReturn(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfList_1OfStockViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfList_1OfStockViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATPurchasesReturnTotals(body?: TaxSearchViewModel | undefined): Observable<StockTotalsViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATPurchasesReturnTotals';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATPurchasesReturnTotals(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATPurchasesReturnTotals(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StockTotalsViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<StockTotalsViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVATPurchasesReturnTotals(
    response: HttpResponseBase,
  ): Observable<StockTotalsViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as StockTotalsViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVATPurchasesReturnExcel(body?: TaxSearchViewModel | undefined): Observable<SystemResponse_1OfReportFileViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Report/GetVATPurchasesReturnExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVATPurchasesReturnExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVATPurchasesReturnExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse_1OfReportFileViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse_1OfReportFileViewModel>;
        }),
      );
  }

  protected processGetVATPurchasesReturnExcel(
    response: HttpResponseBase,
  ): Observable<SystemResponse_1OfReportFileViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse_1OfReportFileViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  getFinSettings(): Observable<FinRecordsSettingViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Setting/GetFinSettings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFinSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFinSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FinRecordsSettingViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FinRecordsSettingViewModel>;
        }),
      );
  }

  protected processGetFinSettings(response: HttpResponseBase): Observable<FinRecordsSettingViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FinRecordsSettingViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  editFinSettings(body?: FinRecordsSettingViewModel | undefined): Observable<StringSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Setting/EditFinSettings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEditFinSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEditFinSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<StringSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<StringSystemResponse>;
        }),
      );
  }

  protected processEditFinSettings(response: HttpResponseBase): Observable<StringSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as StringSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param voucherID (optional)
   * @return OK
   */
  getVoucherDetails(voucherID?: number | undefined): Observable<VoucherViewModel> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherDetails?';
    if (voucherID === null) throw new globalThis.Error("The parameter 'voucherID' cannot be null.");
    else if (voucherID !== undefined) url_ += 'VoucherID=' + encodeURIComponent('' + voucherID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherDetails(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<VoucherViewModel>;
            }
          } else return _observableThrow(response_) as any as Observable<VoucherViewModel>;
        }),
      );
  }

  protected processGetVoucherDetails(response: HttpResponseBase): Observable<VoucherViewModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as VoucherViewModel);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param voucherID (optional)
   * @return OK
   */
  getVoucherPDFByID(voucherID?: number | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherPDFByID?';
    if (voucherID === null) throw new globalThis.Error("The parameter 'voucherID' cannot be null.");
    else if (voucherID !== undefined) url_ += 'VoucherID=' + encodeURIComponent('' + voucherID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherPDFByID(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherPDFByID(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVoucherPDFByID(response: HttpResponseBase): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVoucherInList(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: VoucherSearchViewModel | undefined,
  ): Observable<VoucherViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherInList?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherInList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherInList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<VoucherViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<VoucherViewModel[]>;
        }),
      );
  }

  protected processGetVoucherInList(response: HttpResponseBase): Observable<VoucherViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as VoucherViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVoucherInListCount(body?: VoucherSearchViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherInListCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherInListCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherInListCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetVoucherInListCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVoucherInListReportPDF(body?: VoucherSearchViewModel2 | undefined): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherInListReportPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherInListReportPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherInListReportPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVoucherInListReportPDF(
    response: HttpResponseBase,
  ): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  createVoucherIn(body?: VoucherViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/CreateVoucherIn';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateVoucherIn(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateVoucherIn(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processCreateVoucherIn(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  editVoucherIn(body?: VoucherViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/EditVoucherIn';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEditVoucherIn(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEditVoucherIn(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processEditVoucherIn(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param body (optional)
   * @return OK
   */
  getVoucherOutList(
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    body?: VoucherSearchViewModel | undefined,
  ): Observable<VoucherViewModel[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherOutList?';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherOutList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherOutList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<VoucherViewModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<VoucherViewModel[]>;
        }),
      );
  }

  protected processGetVoucherOutList(response: HttpResponseBase): Observable<VoucherViewModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as VoucherViewModel[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVoucherOutListCount(body?: VoucherSearchViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherOutListCount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherOutListCount(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherOutListCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processGetVoucherOutListCount(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  getVoucherOutListReportPDF(
    body?: VoucherSearchViewModel2 | undefined,
  ): Observable<ReportFileViewModelSystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherOutListReportPDF';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherOutListReportPDF(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherOutListReportPDF(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportFileViewModelSystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReportFileViewModelSystemResponse>;
        }),
      );
  }

  protected processGetVoucherOutListReportPDF(
    response: HttpResponseBase,
  ): Observable<ReportFileViewModelSystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFileViewModelSystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  createVoucherOut(body?: VoucherViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/CreateVoucherOut';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateVoucherOut(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateVoucherOut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processCreateVoucherOut(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  editVoucherOut(body?: VoucherViewModel | undefined): Observable<Int32SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/EditVoucherOut';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEditVoucherOut(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEditVoucherOut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Int32SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<Int32SystemResponse>;
        }),
      );
  }

  protected processEditVoucherOut(response: HttpResponseBase): Observable<Int32SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Int32SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param voucherID (optional)
   * @return OK
   */
  getVoucherAttachments(voucherID?: number | undefined): Observable<ArchiveMapViewMode[]> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/GetVoucherAttachments?';
    if (voucherID === null) throw new globalThis.Error("The parameter 'voucherID' cannot be null.");
    else if (voucherID !== undefined) url_ += 'VoucherID=' + encodeURIComponent('' + voucherID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetVoucherAttachments(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetVoucherAttachments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ArchiveMapViewMode[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ArchiveMapViewMode[]>;
        }),
      );
  }

  protected processGetVoucherAttachments(response: HttpResponseBase): Observable<ArchiveMapViewMode[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ArchiveMapViewMode[]);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param referenceID (optional)
   * @param archiveTypeID (optional)
   * @param notes (optional)
   * @param file (optional)
   * @return OK
   */
  uploadVoucherAttachment(
    referenceID?: number | undefined,
    archiveTypeID?: number | undefined,
    notes?: string | undefined,
    file?: FileParameter | undefined,
  ): Observable<SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/UploadVoucherAttachment?';
    if (referenceID === null) throw new globalThis.Error("The parameter 'referenceID' cannot be null.");
    else if (referenceID !== undefined) url_ += 'ReferenceID=' + encodeURIComponent('' + referenceID) + '&';
    if (archiveTypeID === null) throw new globalThis.Error("The parameter 'archiveTypeID' cannot be null.");
    else if (archiveTypeID !== undefined) url_ += 'ArchiveTypeID=' + encodeURIComponent('' + archiveTypeID) + '&';
    if (notes === null) throw new globalThis.Error("The parameter 'notes' cannot be null.");
    else if (notes !== undefined) url_ += 'Notes=' + encodeURIComponent('' + notes) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new globalThis.Error("The parameter 'file' cannot be null.");
    else content_.append('File', file.data, file.fileName ? file.fileName : 'File');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadVoucherAttachment(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadVoucherAttachment(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse>;
        }),
      );
  }

  protected processUploadVoucherAttachment(response: HttpResponseBase): Observable<SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param archiveMapID (optional)
   * @return OK
   */
  deleteVoucherAttachment(archiveMapID?: number | undefined): Observable<SystemResponse> {
    let url_ = this.baseUrl + '/fin.wrapper/Voucher/DeleteVoucherAttachment?';
    if (archiveMapID === null) throw new globalThis.Error("The parameter 'archiveMapID' cannot be null.");
    else if (archiveMapID !== undefined) url_ += 'ArchiveMapID=' + encodeURIComponent('' + archiveMapID) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteVoucherAttachment(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteVoucherAttachment(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SystemResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SystemResponse>;
        }),
      );
  }

  protected processDeleteVoucherAttachment(response: HttpResponseBase): Observable<SystemResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SystemResponse);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export interface RelatedAccountGroupResultViewModel {
  GroupName?: string | null;
  RelatedAccountsList?: RealtedAccountViewModel[] | null;
}

export interface CostCenterViewModel {
  ID?: number;
  TYPE_ID?: number;
  TITLE_AR?: string | null;
  TITLE_EN?: string | null;
  DESCRIPTION?: string | null;
  NOTES?: string | null;
  PARENT?: number | null;
  TopCompanyCostCenterID?: number;
  IS_ACTIVE?: boolean;
  Code?: string | null;
  ParentPath?: string | null;
  Title?: string | null;
  readonly DisplayTitle?: string | null;
  hasChildren?: boolean;
}

export interface DailyRecordDetailViewModelExt {
  RecordID?: number;
  CompanyCostCenterID?: number;
  RecordTypeID?: number;
  TypeCode?: number;
  Code?: number;
  Amount?: number;
  Title?: string | null;
  FinancialYearID?: number;
  Notes?: string | null;
  RefNo?: string | null;
  RecordDate?: Date;
  IsValid?: boolean;
  IsRelated?: boolean;
  IsPaid?: boolean;
  IsApproved?: boolean;
  ApprovedBy?: string | null;
  ApprovedDate?: Date | null;
  IsPosted?: boolean;
  PostedBy?: string | null;
  PostedDate?: Date | null;
  CreatedBy?: string | null;
  CreatedDate?: Date;
  LastUpdateBy?: string | null;
  LastUpdateDate?: Date | null;
  RecordTypeTitleAr?: string | null;
  RecordTypeTitleEn?: string | null;
  RecordTypeTitle?: string | null;
  SumAmount?: number;
  SumCredit?: number;
  SumDebit?: number;
  IsClosedFYear?: boolean;
  IsCurrentFYear?: boolean;
  StatusIDFYear?: number;
  StatusName?: string | null;
  CostCenterID?: number | null;
  DebitCreditRecordsList?: DebitCridetViewModel[] | null;
  PreviousRecordID?: number | null;
  NextRecordID?: number | null;
  ActivateMultiCurrency?: boolean;
  ActivateMultiCostCenter?: boolean;
}

export interface MonthViewModel {
  ID?: number;
  Title?: string | null;
}

export interface TaxSearchViewModel {
  WarehouseID?: number | null;
  POSID?: number | null;
  VATNumber?: string | null;
  OrderCode?: string | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  Month?: number | null;
  Quarter?: number | null;
  VendorID?: number | null;
  IsValidForPeriodsFilter?: boolean;
  ReferenceNo?: string | null;
  AllPurchasesTaxAccountRecords?: boolean;
}

export enum MessageCode {
  Amount_Comapatiblity = 'Amount_Comapatiblity',
  AddingDone = 'AddingDone',
  CodeError = 'CodeError',
  ErrorInDataLoading = 'ErrorInDataLoading',
  ErrorUpdate = 'ErrorUpdate',
  SaveError = 'SaveError',
  SuccessUpdate = 'SuccessUpdate',
  UserStatus_Deleted = 'UserStatus_Deleted',
  UserStatus_NotExist = 'UserStatus_NotExist',
  UserStatus_Requested = 'UserStatus_Requested',
  UserStatus_Suspended = 'UserStatus_Suspended',
  CanNotInsert = 'CanNotInsert',
  EmployeeNumberUsed = 'EmployeeNumberUsed',
  AccountNotActive = 'AccountNotActive',
  ExceptionHappened = 'ExceptionHappened',
  WrongLoginData = 'WrongLoginData',
  UserAuthLoginIsDisabled = 'UserAuthLoginIsDisabled',
  SuccessLogIn = 'SuccessLogIn',
  WrongVerificationCode = 'WrongVerificationCode',
  ConflictExistingUserEmail = 'ConflictExistingUserEmail',
  NoTemplateFound = 'NoTemplateFound',
  InvalidParameters = 'InvalidParameters',
}

export interface ReportFileViewModel {
  MimeType?: string | null;
  FileNameExtension?: string | null;
  FileByteArr?: string | null;
  FileName?: string | null;
}

export interface SystemResponse_1OfReportFileViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: ReportFileViewModel;
}

export interface SystemResponse_1OfExpensesTotalsViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: ExpensesTotalsViewModel;
}

export interface SystemResponse_1OfGeneralBudgetReportViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: GeneralBudgetReportViewModel;
}

export interface SystemResponse_1OfVATViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: VATViewModel;
}

export interface SystemResponse_1OfList_1OfDebitCridetViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: DebitCridetViewModel[] | null;
}

export interface SystemResponse_1OfList_1OfAccountStatementViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: AccountStatementViewModel[] | null;
}

export interface SystemResponse_1OfList_1OfTrailBalanceViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: TrailBalanceViewModel[] | null;
}

export interface SystemResponse_1OfList_1OfStockViewModel {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: StockViewModel[] | null;
}

export interface SystemResponse_1OfList_1OfString {
  IsSuccess?: boolean;
  MsgCode?: MessageCode;
  Message?: string | null;
  ReturnedValue?: string[] | null;
}

export interface ArchiveMapViewMode {
  ArchiveMapID?: number;
  CompanyID?: number;
  ArchiveTypeID?: number;
  ArchiveTypeName?: string | null;
  FilePath?: string | null;
  FileExtension?: string | null;
  OwnerRef?: string | null;
  Notes?: string | null;
  AddedBy?: string | null;
  LastUpdateBy?: string | null;
  IsActive?: boolean;
  IsDeleted?: boolean;
  AddedDate?: Date;
  LastUpdateDate?: Date | null;
}

export interface ArchivingTypeViewModel {
  ArchiveTypeID?: number;
  OwnerTypeID?: number;
  ArchiveTypeName?: string | null;
  OwnerTypeName?: string | null;
  ArchiveTypeNameAR?: string | null;
  ArchiveTypeNameEN?: string | null;
  IsActive?: boolean;
}

export interface DownloadFileViewModel {
  FileDetails?: ArchiveMapViewMode;
  Content?: string | null;
}

export interface DownloadFileViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode2;
  Message?: string | null;
  ReturnedValue?: DownloadFileViewModel;
}

export enum MessageCode2 {
  Amount_Comapatiblity = 'Amount_Comapatiblity',
  AddingDone = 'AddingDone',
  CodeError = 'CodeError',
  ErrorInDataLoading = 'ErrorInDataLoading',
  ErrorUpdate = 'ErrorUpdate',
  SaveError = 'SaveError',
  SuccessUpdate = 'SuccessUpdate',
  UserStatus_Deleted = 'UserStatus_Deleted',
  UserStatus_NotExist = 'UserStatus_NotExist',
  UserStatus_Requested = 'UserStatus_Requested',
  UserStatus_Suspended = 'UserStatus_Suspended',
  CanNotInsert = 'CanNotInsert',
  EmployeeNumberUsed = 'EmployeeNumberUsed',
  AccountNotActive = 'AccountNotActive',
  ExceptionHappened = 'ExceptionHappened',
  WrongLoginData = 'WrongLoginData',
  UserAuthLoginIsDisabled = 'UserAuthLoginIsDisabled',
  SuccessLogIn = 'SuccessLogIn',
  WrongVerificationCode = 'WrongVerificationCode',
  ConflictExistingUserEmail = 'ConflictExistingUserEmail',
  NoTemplateFound = 'NoTemplateFound',
  InvalidParameters = 'InvalidParameters',
}

export interface SystemResponse {
  IsSuccess?: boolean;
  MessageCode?: MessageCode2;
  Message?: string | null;
  ReturnedValue?: any | null;
}

export enum MessageCode3 {
  Amount_Comapatiblity = 'Amount_Comapatiblity',
  AddingDone = 'AddingDone',
  CodeError = 'CodeError',
  ErrorInDataLoading = 'ErrorInDataLoading',
  ErrorUpdate = 'ErrorUpdate',
  SaveError = 'SaveError',
  SuccessUpdate = 'SuccessUpdate',
  UserStatus_Deleted = 'UserStatus_Deleted',
  UserStatus_NotExist = 'UserStatus_NotExist',
  UserStatus_Requested = 'UserStatus_Requested',
  UserStatus_Suspended = 'UserStatus_Suspended',
  CanNotInsert = 'CanNotInsert',
  EmployeeNumberUsed = 'EmployeeNumberUsed',
  AccountNotActive = 'AccountNotActive',
  ExceptionHappened = 'ExceptionHappened',
  WrongLoginData = 'WrongLoginData',
  UserAuthLoginIsDisabled = 'UserAuthLoginIsDisabled',
  SuccessLogIn = 'SuccessLogIn',
  WrongVerificationCode = 'WrongVerificationCode',
  ConflictExistingUserEmail = 'ConflictExistingUserEmail',
  NoTemplateFound = 'NoTemplateFound',
  InvalidParameters = 'InvalidParameters',
}

export interface OrderAdditionalItemViewModel {
  OrderAdditionalItemID?: number;
  OrderItemID?: number;
  ServiceAddtionalItemValueID?: number;
  ServiceAddtionalItemValueName?: string | null;
  ServiceAddtionalItemName?: string | null;
  ServiceAddtionalItemValueName_AR?: string | null;
  ServiceAddtionalItemValueName_EN?: string | null;
  ServiceAddtionalItemName_AR?: string | null;
  ServiceAddtionalItemName_EN?: string | null;
  OrignalUnitPrice?: number;
  SellingUnitPrice?: number;
}

export interface OrderAddressViewModel {
  OrderID?: number;
  FirstName?: string | null;
  LastName?: string | null;
  Mobile?: string | null;
  Email?: string | null;
  VATNumber?: string | null;
  Title?: string | null;
  CityID?: number | null;
  CityName?: string | null;
  CountryID?: number | null;
  CountryCode?: string | null;
  CountryName?: string | null;
  Description?: string | null;
  Street?: string | null;
  District?: string | null;
  Region?: string | null;
  PostalCode?: string | null;
  BuildingNumber?: string | null;
  AdditionalNumber?: string | null;
  Latitude?: number | null;
  Longitude?: number | null;
  AddedDate?: Date;
  AddedBy?: string | null;
}

export interface OrderBaseViewModel {
  OrderTypeName?: string | null;
  OrderID?: number;
  CustomerID?: number;
  CustomerName?: string | null;
  CustomerFirstName?: string | null;
  CustomerLastName?: string | null;
  CustomerMobile?: string | null;
  CustomerVATNumber?: string | null;
  CompanyID?: number;
  OrderStatusID?: number;
  OrderTypeID?: number;
  PoSID?: number;
  OrderCode?: string | null;
  OrderRefNo?: string | null;
  RefNo?: string | null;
  OrderStatusName?: string | null;
  TotalPrice?: number;
  OrderChanel?: string | null;
  ChanelVersion?: string | null;
  ChanelDevice?: string | null;
  AddedBy?: string | null;
  AddedDate?: Date;
  PoSCode?: string | null;
  PoSName?: string | null;
  SellerName?: string | null;
  SellerID?: number | null;
  RemainigAmount?: number;
  WarehouseID?: number | null;
  WarehouseName?: string | null;
  OrderDate?: Date;
  TotalTax?: number;
  TotalWithoutTax?: number;
  Price?: number;
  Discount?: number;
  UUID?: string | null;
  QrCode?: string | null;
  CashierOperationID?: number | null;
}

export interface OrderBaseViewModelListAPIResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode3;
  Message?: string | null;
  ReturnedValue?: OrderBaseViewModel[] | null;
}

export interface OrderItemGroupViewModel {
  OrderItemGroupID?: number;
  OrderItemID?: number;
  PropertyID?: number;
  PropertyTitle?: string | null;
  PropertyTitleEn?: string | null;
  VauleID?: number;
  ValueTitle?: string | null;
  ValueTitleEn?: string | null;
}

export interface OrderItemTaxViewModel {
  OrderItemTaxID?: number;
  TaxTypeID?: number;
  Name?: string | null;
  OrderItemID?: number;
  TaxTypeRatio?: number;
  TaxAmount?: number;
  TaxTypeOrder?: number;
  AddBy?: string | null;
  AddDate?: Date;
}

export interface OrderItemViewModel {
  OrderItemID?: number;
  OrderID?: number;
  ServiceID?: number;
  ServiceTypeID?: number;
  GroupID?: number | null;
  StockUnitID?: number;
  Quantity?: number;
  Rate?: number;
  OrignalUnitPrice?: number;
  ProductPriceDisplay?: number;
  SellingUnitPrice?: number;
  SellingUnitPriceDisplay?: number;
  Discount?: number;
  DiscountDisplay?: number;
  Tax?: number;
  TaxDisplay?: number;
  OrignalTaxPercentage?: number | null;
  Currency?: string | null;
  POSRefID?: number | null;
  IsCanceled?: boolean;
  IsCashe?: boolean;
  AddedBy?: string | null;
  AddedDate?: Date;
  LastUpdateBy?: string | null;
  LastUpdateDate?: Date | null;
  ServicePhoto?: string | null;
  ServiceName?: string | null;
  UnitTitleAR?: string | null;
  UnitTitleEN?: string | null;
  ServiceNameAR?: string | null;
  ServiceNameEN?: string | null;
  ServiceCode?: string | null;
  ProductReferenceCode?: string | null;
  ServiceClassificationId?: number;
  ServiceClassificationName?: string | null;
  ServiceClassificationNameAR?: string | null;
  ServiceClassificationNameEN?: string | null;
  Sell_Total_Price?: number;
  CustomerRating?: number;
  CustomerNotes?: string | null;
  ItemWieght?: number;
  PeriodToReturn?: number | null;
  PeriodToExchange?: number | null;
  ServiceStockGroupID?: number;
  ExpiryDate?: Date | null;
  OrderItemGroupValues?: OrderItemGroupViewModel[] | null;
  OrderAdditionalItemValues?: OrderAdditionalItemViewModel[] | null;
  ServicePropertiesTitleAr?: string | null;
  ServicePropertiesTitleEn?: string | null;
  ServicePropertiesTitle?: string | null;
  Note?: string | null;
  SerialNumber?: string | null;
  BatchNumber?: string | null;
  NetWeight?: number | null;
  AdditionsWeight?: number | null;
  OrderItemTaxes?: OrderItemTaxViewModel[] | null;
}

export interface OrderReturnItemTaxViewModel {
  OrderReturnItemTaxID?: number;
  TaxTypeID?: number;
  Name?: string | null;
  OrderReturnItemID?: number;
  TaxTypeRatio?: number;
  TaxAmount?: number;
  TaxTypeOrder?: number;
  AddBy?: string | null;
  AddDate?: Date;
}

export interface OrderReturnItemViewModel {
  OrderReturnItemID?: number;
  OrderReturnID?: number;
  OrderItemID?: number;
  ServiceID?: number;
  ClassificationID?: number;
  GroupID?: number | null;
  StockUnitID?: number;
  ServiceTypeID?: number;
  Quantity?: number;
  OriginalCostUnitPrice?: number;
  OrignalSellingUnitPrice?: number;
  ReturnUnitPrice?: number;
  Discount?: number;
  Tax?: number;
  ServiceStockGroupID?: number;
  ExpiryDate?: Date | null;
  ItemDetails?: OrderItemViewModel;
  SerialNumber?: string | null;
  BatchNumber?: string | null;
  OrderReturnItemTaxes?: OrderReturnItemTaxViewModel[] | null;
}

export interface OrderReturnPaymentViewModel {
  OrderPaymentID?: number;
  OrderReturnID?: number;
  PaymentGatewayTypeID?: number;
  PaymentGatewayTypeTitle?: string | null;
  PaymentGatewayID?: number | null;
  CardNumber?: string | null;
  CardHolder?: string | null;
  CardType?: string | null;
  Amount?: number;
  AddedDate?: Date;
  AddedBy?: string | null;
  PaymentRef?: string | null;
  ReferenceCode?: string | null;
  CashierOperationID?: number | null;
}

export interface OrderReturnViewModel {
  OrderID?: number;
  CustomerID?: number;
  CustomerName?: string | null;
  CustomerFirstName?: string | null;
  CustomerLastName?: string | null;
  CustomerMobile?: string | null;
  CustomerVATNumber?: string | null;
  CompanyID?: number;
  OrderStatusID?: number;
  OrderTypeID?: number;
  PoSID?: number;
  OrderCode?: string | null;
  OrderRefNo?: string | null;
  RefNo?: string | null;
  OrderStatusName?: string | null;
  TotalPrice?: number;
  OrderChanel?: string | null;
  ChanelVersion?: string | null;
  ChanelDevice?: string | null;
  AddedBy?: string | null;
  AddedDate?: Date;
  PoSCode?: string | null;
  PoSName?: string | null;
  SellerName?: string | null;
  SellerID?: number | null;
  RemainigAmount?: number;
  WarehouseID?: number | null;
  WarehouseName?: string | null;
  OrderDate?: Date;
  TotalTax?: number;
  TotalWithoutTax?: number;
  Price?: number;
  UUID?: string | null;
  QrCode?: string | null;
  CashierOperationID?: number | null;
  OrderReturnID?: number;
  ReturnsCount?: number;
  OrderItemsCount?: number;
  OrderReturnCode?: string | null;
  BranchCode?: string | null;
  CostPrice?: number;
  NetPrice?: number;
  TotalOrignalSellingPrice?: number;
  DiscountedSellingPrice?: number;
  TotalReturnPrice?: number;
  TotalReturnPriceWithTax?: number;
  TotalQuantity?: number;
  TotalCostPrice?: number;
  Discount?: number;
  Tax?: number;
  Comments?: string | null;
  OrderChannel?: string | null;
  ChannelVersion?: string | null;
  ChannelDevice?: string | null;
  OrderReturnDate?: Date;
  OrderReturnItems?: OrderReturnItemViewModel[] | null;
  OrderReturnPaymentsList?: OrderReturnPaymentViewModel[] | null;
  FullCustomerAddress?: string | null;
  POSDataLogID?: number | null;
  BatchNumber?: string | null;
  SerialNumber?: string | null;
  FullGroupTitle?: string | null;
  OrderAddress?: OrderAddressViewModel;
  IsForExchange?: boolean;
}

export interface OrderReturnViewModelListAPIResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode3;
  Message?: string | null;
  ReturnedValue?: OrderReturnViewModel[] | null;
}

export interface OrderTotalsViewModel {
  CompanyID?: number;
  SalesCount?: number;
  TotalPrice?: number;
  TotalTax?: number;
  TotalCost?: number;
  TotalWithoutTax?: number;
  Price?: number;
  Discount?: number;
}

export interface OrderTotalsViewModelAPIResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode3;
  Message?: string | null;
  ReturnedValue?: OrderTotalsViewModel;
}

export interface AccountCurrencyViewModel {
  FinAccountID?: number;
  CompanyCostCenterID?: number;
  CurrencyTitle?: string | null;
  CurrencyID?: number | null;
  CurrencyRate?: number | null;
  HasRecords?: boolean | null;
}

export interface AccountRecordSearchCratiria {
  CostCenterID?: number | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  AccountID?: number | null;
  ShowActive?: boolean | null;
  ShowZeros?: boolean | null;
  TaxVendorID?: number | null;
  CurrencyID?: number | null;
  VATNO?: string | null;
  FYearStartDate?: Date | null;
  FYearEndDate?: Date | null;
  RecordDate?: Date | null;
  Total?: number | null;
  IntShowZeros?: number | null;
  FinYearID?: number | null;
  UnConfirmedRecordsCount?: number | null;
  RecordTypeID?: number | null;
  DailyRecordID?: number | null;
  StatusList?: number[] | null;
  CostCenterIDs?: number[] | null;
  IsValid?: boolean | null;
  IsApproved?: boolean | null;
  IsPaid?: boolean | null;
  IsRelated?: boolean | null;
  IsPosted?: boolean | null;
  RecordCode?: number | null;
  RecordTitle?: string | null;
  IncludeRecordWithNoDetails?: boolean | null;
}

export interface BooleanSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: boolean;
}

export interface CurrencyViewModel {
  CurrencyID?: number;
  Title?: string | null;
  TitleAr?: string | null;
  TitleEn?: string | null;
  DisplayTitle?: string | null;
  Code?: string | null;
  CodeAr?: string | null;
  CodeEn?: string | null;
  Rate?: number;
  IsDefault?: boolean;
}

export interface DailyRecordDetailViewModel {
  RecordID?: number;
  CompanyCostCenterID?: number;
  RecordTypeID?: number;
  TypeCode?: number;
  Code?: number;
  Amount?: number;
  Title?: string | null;
  FinancialYearID?: number;
  Notes?: string | null;
  RefNo?: string | null;
  RecordDate?: Date;
  IsValid?: boolean;
  IsRelated?: boolean;
  IsPaid?: boolean;
  IsApproved?: boolean;
  ApprovedBy?: string | null;
  ApprovedDate?: Date | null;
  IsPosted?: boolean;
  PostedBy?: string | null;
  PostedDate?: Date | null;
  CreatedBy?: string | null;
  CreatedDate?: Date;
  LastUpdateBy?: string | null;
  LastUpdateDate?: Date | null;
  RecordTypeTitleAr?: string | null;
  RecordTypeTitleEn?: string | null;
  RecordTypeTitle?: string | null;
  SumAmount?: number;
  SumCredit?: number;
  SumDebit?: number;
  IsClosedFYear?: boolean;
  IsCurrentFYear?: boolean;
  StatusIDFYear?: number;
  StatusName?: string | null;
  CostCenterID?: number | null;
  DebitCreditRecordsList?: DebitCridetViewModel[] | null;
  PreviousRecordID?: number | null;
  NextRecordID?: number | null;
}

export interface DailyRecordDetailViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: DailyRecordDetailViewModel;
}

export interface DailyRecordViewModel {
  RecordID?: number;
  CompanyCostCenterID?: number;
  RecordTypeID?: number;
  TypeCode?: number;
  Code?: number;
  Amount?: number;
  Title?: string | null;
  FinancialYearID?: number;
  Notes?: string | null;
  RefNo?: string | null;
  RecordDate?: Date;
  IsValid?: boolean;
  IsRelated?: boolean;
  IsPaid?: boolean;
  IsApproved?: boolean;
  ApprovedBy?: string | null;
  ApprovedDate?: Date | null;
  IsPosted?: boolean;
  PostedBy?: string | null;
  PostedDate?: Date | null;
  CreatedBy?: string | null;
  CreatedDate?: Date;
  LastUpdateBy?: string | null;
  LastUpdateDate?: Date | null;
  RecordTypeTitleAr?: string | null;
  RecordTypeTitleEn?: string | null;
  RecordTypeTitle?: string | null;
  SumAmount?: number;
  SumCredit?: number;
  SumDebit?: number;
  IsClosedFYear?: boolean;
  IsCurrentFYear?: boolean;
  StatusIDFYear?: number;
  StatusName?: string | null;
  CostCenterID?: number | null;
}

export interface DailyRecordViewModelListSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: DailyRecordViewModel[] | null;
}

export interface DailyRecordViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: DailyRecordViewModel;
}

export interface DebitCridetViewModel {
  ID?: number;
  DailyRecordID?: number;
  DailyRecordDate?: Date;
  DailyRecordCode?: number;
  DailyRecordTypeCode?: number;
  TopCompanyCostCenterID?: number;
  FinancialTreeID?: number;
  FinancialTreeTitle?: string | null;
  FinancialTreeCode?: string | null;
  CostCenterID?: number;
  CostCenterCode?: string | null;
  CostCenterTitle?: string | null;
  Title?: string | null;
  Notes?: string | null;
  IsCredit?: boolean;
  IsCreditInt?: string | null;
  Amount?: number;
  DebitAmount?: number;
  CreditAmount?: number;
  EnteranceAmount?: number;
  CurrencyID?: number;
  CurrencyRate?: number;
  SelectedCurrency?: CurrencyViewModel;
  CurrencyDebitAmount?: number;
  CurrencyCreditAmount?: number;
  VAT_NO?: string | null;
  Bill_No?: string | null;
  CompanyName?: string | null;
  BillDate?: Date | null;
  CreatedBy?: string | null;
  CreatedDate?: Date;
  LastUpdateBy?: string | null;
  LastUpdateDate?: Date | null;
  TaxAmount?: number;
  TotalAmount?: number;
  SelectedAccount?: FinancialTreeViewModel;
}

export interface DecimalSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: number;
}

export interface FinRecordTypeViewModel {
  RecordTypeID?: number;
  TitleAr?: string | null;
  TitleEn?: string | null;
  AutoApproved?: boolean;
}

export interface FinRecordsSettingViewModel {
  CompanyID?: number;
  IsAgregratedRecord?: boolean;
  AutoPostAllBillsDaily?: boolean;
  AutoPostPostpaidBills?: boolean;
  PostpaidBillsPostingType?: number;
}

export interface FinancialTreeViewModel {
  ID?: number;
  CompanyCostCenterID?: number;
  Code?: string | null;
  TItle?: string | null;
  TitleEnglish?: string | null;
  Parent?: number | null;
  NodePath?: string | null;
  IsCredit?: boolean;
  IsParent?: boolean;
  IsManagedBySystem?: boolean;
  Notes?: string | null;
  IsHidden?: boolean;
  VAT_NO?: string | null;
  HasChildren?: boolean;
  DisplayTitle?: string | null;
  Parentflag?: number;
  CurrencyID?: number | null;
  Balance?: number | null;
  CurrencyTitle?: string | null;
  HasRecords?: boolean;
}

export interface FinancialTreeViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: FinancialTreeViewModel;
}

export interface FinancialYearStatusViewModel {
  FinancialYearStatusID?: number;
  Title?: string | null;
  TitleAr?: string | null;
  TitleEn?: string | null;
}

export interface FinancialYearViewModel {
  FinancailYearID?: number;
  CompanyID?: number;
  Title?: string | null;
  StatusID?: number;
  StatusName?: string | null;
  StartDate?: Date;
  EndDate?: Date;
  IsCurrent?: boolean;
  IsClosed?: boolean | null;
  OpeniningRecordID?: number | null;
  ClosingRecordID?: number | null;
  CreatedByID?: number | null;
  CreatedByUserName?: string | null;
  ClosedByIUserName?: string | null;
  ClosedByID?: number | null;
}

export interface Int32SystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: number;
}

export enum MessageCode4 {
  Amount_Comapatiblity = 'Amount_Comapatiblity',
  AddingDone = 'AddingDone',
  CodeError = 'CodeError',
  ErrorInDataLoading = 'ErrorInDataLoading',
  ErrorUpdate = 'ErrorUpdate',
  SaveError = 'SaveError',
  SuccessUpdate = 'SuccessUpdate',
  UserStatus_Deleted = 'UserStatus_Deleted',
  UserStatus_NotExist = 'UserStatus_NotExist',
  UserStatus_Requested = 'UserStatus_Requested',
  UserStatus_Suspended = 'UserStatus_Suspended',
  CanNotInsert = 'CanNotInsert',
  EmployeeNumberUsed = 'EmployeeNumberUsed',
  AccountNotActive = 'AccountNotActive',
  ExceptionHappened = 'ExceptionHappened',
  WrongLoginData = 'WrongLoginData',
  UserAuthLoginIsDisabled = 'UserAuthLoginIsDisabled',
  SuccessLogIn = 'SuccessLogIn',
  WrongVerificationCode = 'WrongVerificationCode',
  ConflictExistingUserEmail = 'ConflictExistingUserEmail',
  NoTemplateFound = 'NoTemplateFound',
  InvalidParameters = 'InvalidParameters',
}

export interface POSPaymentTypeAccountViewModel {
  POSPaymentTypeAccountID?: number;
  POSID?: number;
  POSName?: string | null;
  CompanyID?: number;
  PaymentGatewayTypeID?: number;
  PaymentGatewayTypeTitle?: string | null;
  AccountID?: number | null;
  AccountTitle?: string | null;
  AddedBy?: string | null;
  AddedDate?: Date;
  LastUpdatedBy?: string | null;
  LastUpdateDate?: Date | null;
}

export interface PaymentTypeViewModel {
  PaymentTypeID?: number;
  Title?: string | null;
}

export interface PostBalancesViewModel {
  OpeningRecordID?: number | null;
  OpeningBalance?: number | null;
}

export interface PostBalancesViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: PostBalancesViewModel;
}

export interface RealtedAccountViewModel {
  CompanyCostCenterID?: number;
  RelatedAccountID?: number;
  TItle?: string | null;
  TItleEnglish?: string | null;
  Notes?: string | null;
  AccountID?: number;
  RelatedFinancialName?: string | null;
  GroupName?: string | null;
  DisplayOrder?: number;
}

export interface StringSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: string | null;
}

export interface SystemResponse2 {
  IsSuccess?: boolean;
  MessageCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: any | null;
}

export interface TaxVendorViewModel {
  TaxVendorID?: number;
  CompanyID?: number;
  VendorName?: string | null;
  VATNo?: string | null;
  IsActive?: boolean;
  AddedBy?: string | null;
  AddedDate?: Date;
}

export interface TaxVendorViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode4;
  Message?: string | null;
  ReturnedValue?: TaxVendorViewModel;
}

export interface VoucherLogViewModel {
  VoucherID?: number;
  IsImport?: boolean;
  Amount?: number;
  AmountTitle?: string | null;
  VoucherDate?: Date;
  Title?: string | null;
  Description?: string | null;
  PaymentTypeID?: number;
  NumberOftheCheque?: string | null;
  BankTitle?: string | null;
  FromAccount?: number;
  ToAccount?: number;
  CostCenterID?: number;
  TransfereNum?: string | null;
  ECRReferenceNo?: string | null;
  VoucherCode?: number;
  VoucherDateString?: string | null;
  PaymentTypeTitle?: string | null;
  DailyRecordID?: number;
  AddedByID?: number;
  AddedByUserName?: string | null;
  AddedDate?: Date;
  CurrencyID?: number | null;
  CurrencyAmount?: number;
  CurrencyRate?: number | null;
  CurrencyCode?: string | null;
  DefaultCurrencyCode?: string | null;
  IsDefaultCurrency?: boolean;
  AmountInDefaultCurr?: number | null;
  DailyRecodrStauts?: string | null;
  DailyRecodrDate?: Date;
  DailyRecodrAmount?: number;
  DailyRecodrTitle?: string | null;
  DailyRecodrCode?: number;
  CompanyCostCenterID?: number;
  FinaicialFromAccountCode?: string | null;
  FinaicialFromAccountTitle?: string | null;
  FinaicialFromAccountCostCenter?: string | null;
  FinaicialFromAccountAmountTitle?: string | null;
  FinaicialFromAccountCostCenterCode?: string | null;
  FinaicialToAccountCode?: string | null;
  FinaicialToAccountTitle?: string | null;
  FinaicialToAccountCostCenter?: string | null;
  FinaicialToAccountCostCenterCode?: string | null;
  FinaicialToAccountAmountTitle?: string | null;
  FinancilYearID?: number;
  VoucherLogID?: number;
}

export interface VoucherSearchViewModel {
  VoucherID?: number | null;
  VoucherCode?: number | null;
  FromAccount?: number | null;
  ToAccount?: number | null;
  Amount?: number | null;
  VoucherDate?: Date | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  Title?: string | null;
  CostCenters?: number[] | null;
  AddedByID?: number | null;
}

export interface VoucherViewModel {
  VoucherID?: number;
  IsImport?: boolean;
  Amount?: number;
  AmountTitle?: string | null;
  VoucherDate?: Date;
  Title?: string | null;
  Description?: string | null;
  PaymentTypeID?: number;
  NumberOftheCheque?: string | null;
  BankTitle?: string | null;
  FromAccount?: number;
  ToAccount?: number;
  CostCenterID?: number;
  TransfereNum?: string | null;
  ECRReferenceNo?: string | null;
  VoucherCode?: number;
  VoucherDateString?: string | null;
  PaymentTypeTitle?: string | null;
  DailyRecordID?: number;
  AddedByID?: number;
  AddedByUserName?: string | null;
  AddedDate?: Date;
  CurrencyID?: number | null;
  CurrencyAmount?: number;
  CurrencyRate?: number | null;
  CurrencyCode?: string | null;
  DefaultCurrencyCode?: string | null;
  IsDefaultCurrency?: boolean;
  AmountInDefaultCurr?: number | null;
  DailyRecodrStauts?: string | null;
  DailyRecodrDate?: Date;
  DailyRecodrAmount?: number;
  DailyRecodrTitle?: string | null;
  DailyRecodrCode?: number;
  CompanyCostCenterID?: number;
  FinaicialFromAccountCode?: string | null;
  FinaicialFromAccountTitle?: string | null;
  FinaicialFromAccountCostCenter?: string | null;
  FinaicialFromAccountAmountTitle?: string | null;
  FinaicialFromAccountCostCenterCode?: string | null;
  FinaicialToAccountCode?: string | null;
  FinaicialToAccountTitle?: string | null;
  FinaicialToAccountCostCenter?: string | null;
  FinaicialToAccountCostCenterCode?: string | null;
  FinaicialToAccountAmountTitle?: string | null;
  FinancilYearID?: number;
  PreviousVoucherID?: number | null;
  NextVoucherID?: number | null;
  VoucherLogs?: VoucherLogViewModel[] | null;
}

export interface AccountRecordSearchCratiria2 {
  CostCenterID?: number | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  AccountID?: number | null;
  ShowActive?: boolean | null;
  ShowZeros?: boolean | null;
  GroupByMainAccounts?: boolean | null;
  TaxVendorID?: number | null;
  CurrencyID?: number | null;
  VATNO?: string | null;
  FYearStartDate?: Date | null;
  FYearEndDate?: Date | null;
  RecordDate?: Date | null;
  Total?: number | null;
  IntShowZeros?: number | null;
  FinYearID?: number | null;
  UnConfirmedRecordsCount?: number | null;
  RecordTypeID?: number | null;
  DailyRecordID?: number | null;
  StatusList?: number[] | null;
  CostCenterIDs?: number[] | null;
  IsValid?: boolean | null;
  IsApproved?: boolean | null;
  IsPaid?: boolean | null;
  IsRelated?: boolean | null;
  IsPosted?: boolean | null;
  RecordCode?: number | null;
  RecordTitle?: string | null;
  IncludeRecordWithNoDetails?: boolean | null;
  IsShowOpeningBalance?: boolean;
  RestrictByFinYear?: boolean;
}

export interface AccountStatementViewModel {
  DebitCridetRecordID?: number;
  DailyRecordID?: number;
  RecordTypeID?: number;
  Amount?: number;
  IsCredit?: boolean | null;
  FinancialTreeID?: number | null;
  CostCenterID?: number;
  CostCenterTitle?: string | null;
  RefNo?: string | null;
  Debit?: number | null;
  Credit?: number | null;
  Balance?: number | null;
  Code?: number | null;
  Title?: string | null;
  RecordTypeTitle?: string | null;
  TypeCode?: number;
  RecordDate?: Date | null;
  CreatedBy?: string | null;
  CreatedDate?: Date | null;
  FinAccountTitle?: string | null;
}

export interface DailyFinRecordByTypeViewModel {
  RecordTypeID?: number;
  RecordTypeName?: string | null;
  TotalCount?: number;
  TotalAmount?: number;
}

export interface DailyRecordViewModel2 {
  RecordID?: number;
  CompanyCostCenterID?: number;
  RecordTypeID?: number;
  TypeCode?: number;
  Code?: number;
  Amount?: number;
  Title?: string | null;
  FinancialYearID?: number;
  Notes?: string | null;
  RefNo?: string | null;
  RecordDate?: Date;
  IsValid?: boolean;
  IsRelated?: boolean;
  IsPaid?: boolean;
  IsApproved?: boolean;
  ApprovedBy?: string | null;
  ApprovedDate?: Date | null;
  IsPosted?: boolean;
  PostedBy?: string | null;
  PostedDate?: Date | null;
  CreatedBy?: string | null;
  CreatedDate?: Date;
  LastUpdateBy?: string | null;
  LastUpdateDate?: Date | null;
  RecordTypeTitleAr?: string | null;
  RecordTypeTitleEn?: string | null;
  RecordTypeTitle?: string | null;
  SumAmount?: number;
  SumCredit?: number;
  SumDebit?: number;
  IsClosedFYear?: boolean;
  IsCurrentFYear?: boolean;
  StatusIDFYear?: number;
  StatusName?: string | null;
  CostCenterID?: number | null;
}

export interface ExpensesTotalsViewModel {
  TaxTotal?: number;
  TotalDebitAmount?: number;
  TotalWithTax?: number;
  RecordsCount?: number;
}

export interface FinCountersViewModel {
  DailyRecordsCounter?: number;
  VouchersCounter?: number;
  AccountsCounter?: number;
  CostCentersCounter?: number;
  CostCenterID?: number;
  CostCenterName?: string | null;
  DailyRecordsAmount?: number;
}

export interface GeneralBudgetReportViewModel {
  Assets?: TrailBalanceViewModel[] | null;
  AssetsTotal?: number;
  Liabilities?: TrailBalanceViewModel[] | null;
  LiabilitiesTotal?: number;
  Equity?: TrailBalanceViewModel[] | null;
  EquityTotal?: number;
}

export interface GeneralBudgetViewModel {
  ID?: number;
  Code?: string | null;
  Title?: string | null;
  Type?: number;
  Balance?: number;
  Percent?: string | null;
}

export interface GeneralLedgerViewModel {
  ID?: number;
  IsCredit?: boolean;
  Parent?: number | null;
  Code?: string | null;
  TItle?: string | null;
  TitleEnglish?: string | null;
  Notes?: string | null;
  TitleWithCode?: string | null;
  TitleWithCodeEn?: string | null;
  TotalDebit?: number | null;
  TotalCredit?: number | null;
  Balance?: number | null;
}

export interface IncomeStatmentAccountViewModel {
  ID?: number;
  IsCredit?: boolean;
  Parent?: number | null;
  Code?: string | null;
  TItle?: string | null;
  TitleEnglish?: string | null;
  Notes?: string | null;
  TitleWithCode?: string | null;
  TitleWithCodeEn?: string | null;
  TotalDebit?: number;
  TotalCredit?: number;
  Balance?: number;
  Percent?: number;
}

export interface IncomeStatmentViewModel {
  RevenueList?: IncomeStatmentAccountViewModel[] | null;
  ExpenseList?: IncomeStatmentAccountViewModel[] | null;
  ChartRevenueList?: IncomeStatmentAccountViewModel[] | null;
  ChartExpenseList?: IncomeStatmentAccountViewModel[] | null;
  TotalRevenues?: number;
  TotalExpenses?: number;
  NetLoss?: number;
  NetProfit?: number;
  Net?: number;
  NetMessage?: string | null;
}

export interface IncomeStatmentViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode5;
  Message?: string | null;
  ReturnedValue?: IncomeStatmentViewModel;
}

export interface Int32SystemResponse2 {
  IsSuccess?: boolean;
  MsgCode?: MessageCode5;
  Message?: string | null;
  ReturnedValue?: number;
}

export enum MessageCode5 {
  Amount_Comapatiblity = 'Amount_Comapatiblity',
  AddingDone = 'AddingDone',
  CodeError = 'CodeError',
  ErrorInDataLoading = 'ErrorInDataLoading',
  ErrorUpdate = 'ErrorUpdate',
  SaveError = 'SaveError',
  SuccessUpdate = 'SuccessUpdate',
  UserStatus_Deleted = 'UserStatus_Deleted',
  UserStatus_NotExist = 'UserStatus_NotExist',
  UserStatus_Requested = 'UserStatus_Requested',
  UserStatus_Suspended = 'UserStatus_Suspended',
  CanNotInsert = 'CanNotInsert',
  EmployeeNumberUsed = 'EmployeeNumberUsed',
  AccountNotActive = 'AccountNotActive',
  ExceptionHappened = 'ExceptionHappened',
  WrongLoginData = 'WrongLoginData',
  UserAuthLoginIsDisabled = 'UserAuthLoginIsDisabled',
  SuccessLogIn = 'SuccessLogIn',
  WrongVerificationCode = 'WrongVerificationCode',
  ConflictExistingUserEmail = 'ConflictExistingUserEmail',
  NoTemplateFound = 'NoTemplateFound',
  InvalidParameters = 'InvalidParameters',
}

export interface ReportFileViewModel2 {
  MimeType?: string | null;
  FileNameExtension?: string | null;
  FileByteArr?: string | null;
  FileName?: string | null;
}

export interface ReportFileViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode5;
  Message?: string | null;
  ReturnedValue?: ReportFileViewModel2;
}

export interface TrailBalanceViewModel {
  Type?: number;
  TypeTitle?: string | null;
  SubType?: number;
  SubTypeTitle?: string | null;
  TitleEnglish?: string | null;
  ID?: number;
  Code?: string | null;
  NodePath?: string | null;
  Parent?: number | null;
  CurrntCredit?: number;
  CurrntDebit?: number;
  FinalCredit?: number;
  FinalDebit?: number;
  OpningCredit?: number;
  OpningDebit?: number;
  Notes?: string | null;
  TItle?: string | null;
  IsCredit?: boolean;
  IsParent?: boolean;
}

export interface VATViewModel {
  BasicTaxableSales?: number;
  NonTaxableSales?: number;
  Exports?: number;
  SalesVAT?: number;
  BasicTaxableReturnSales?: number;
  NonTaxableReturnSales?: number;
  ReturnSalesVAT?: number;
  NetSalesVAT?: number;
  TotalSales?: number;
  BasicTaxablePurchases?: number;
  NonTaxablePurchases?: number;
  TotalPurchasesVAT?: number;
  ReturnPurchaseTaxableAmount?: number;
  ReturnPurchaseVAT?: number;
  Expensive?: number;
  ExpensiveVAT?: number;
  NetTaxableSales?: number;
  TotalPurchases_Expensive_VAT?: number;
  TotalPurchases_Expensive?: number;
  TotalPurchases?: number;
  NetVAT?: number;
  StartDate?: Date;
  EndDate?: Date;
}

export interface VoucherSearchViewModel2 {
  VoucherID?: number | null;
  VoucherCode?: number | null;
  FromAccount?: number | null;
  ToAccount?: number | null;
  Amount?: number | null;
  VoucherDate?: Date | null;
  StartDate?: Date | null;
  EndDate?: Date | null;
  Title?: string | null;
  CostCenters?: number[] | null;
  AddedByID?: number | null;
}

export enum MessageCode6 {
  Amount_Comapatiblity = 'Amount_Comapatiblity',
  AddingDone = 'AddingDone',
  CodeError = 'CodeError',
  ErrorInDataLoading = 'ErrorInDataLoading',
  ErrorUpdate = 'ErrorUpdate',
  SaveError = 'SaveError',
  SuccessUpdate = 'SuccessUpdate',
  UserStatus_Deleted = 'UserStatus_Deleted',
  UserStatus_NotExist = 'UserStatus_NotExist',
  UserStatus_Requested = 'UserStatus_Requested',
  UserStatus_Suspended = 'UserStatus_Suspended',
  CanNotInsert = 'CanNotInsert',
  EmployeeNumberUsed = 'EmployeeNumberUsed',
  AccountNotActive = 'AccountNotActive',
  ExceptionHappened = 'ExceptionHappened',
  WrongLoginData = 'WrongLoginData',
  UserAuthLoginIsDisabled = 'UserAuthLoginIsDisabled',
  SuccessLogIn = 'SuccessLogIn',
  WrongVerificationCode = 'WrongVerificationCode',
  ConflictExistingUserEmail = 'ConflictExistingUserEmail',
  NoTemplateFound = 'NoTemplateFound',
  InvalidParameters = 'InvalidParameters',
}

export interface StockDetailViewModel {
  StockDetailID?: number;
  StockOperationID?: number;
  ServiceID?: number | null;
  ServiceName?: string | null;
  ServiceNameAr?: string | null;
  ServiceNameEn?: string | null;
  ServiceCode?: string | null;
  ServiceSellingPrice?: number;
  ClassificationID?: number | null;
  ServiceStockGroupID?: number;
  ServiceCostPrice?: number;
  TotalCostPrice?: number;
  ServiceDiscount?: number;
  ServiceTotalTaxAmount?: number;
  ServiceTaxPercentage?: number;
  ServiceNetTotal?: number;
  Quantity?: number;
  AddedBy?: string | null;
  AddedDate?: Date;
  PropertiesTitle?: string | null;
  FullGroupTitle?: string | null;
  PropertiesWithValues?: string | null;
  ExpiryDate?: Date | null;
  StockUnitID?: number;
  UnitTitle?: string | null;
  UnitName?: string | null;
  GroupID?: number | null;
  ReferenceCode?: string | null;
  ServiceTypeID?: number;
  BatchNumber?: string | null;
  SerialNumber?: string | null;
}

export interface StockTotalsViewModel {
  OperationsCount?: number;
  BillAmount?: number | null;
  BillAmountAfterDiscount?: number | null;
  BillDiscountAmount?: number | null;
  BillTaxAmount?: number | null;
  BillTotalAmount?: number | null;
}

export interface StockTotalsViewModelSystemResponse {
  IsSuccess?: boolean;
  MsgCode?: MessageCode6;
  Message?: string | null;
  ReturnedValue?: StockTotalsViewModel;
}

export interface StockViewModel {
  CompanyID?: number;
  StockOperationID?: number;
  VendorID?: number | null;
  WarehouseID?: number;
  WarehouseName?: string | null;
  ToWarehouseID?: number | null;
  ToWarehouseName?: string | null;
  ReferenceNumber?: string | null;
  BillDate?: Date | null;
  BillAmountWithoutTax?: number | null;
  BillDiscountAmount?: number | null;
  BillTaxAmount?: number | null;
  BillTotalAmount?: number | null;
  FinDailyRecordID?: number | null;
  OperationTypeID?: number;
  OperationTypeName?: string | null;
  OperationStatusID?: number;
  OperationStatusTitle?: string | null;
  IsActive?: boolean;
  AddedDate?: Date;
  AddedBy?: string | null;
  Notes?: string | null;
  VendorName?: string | null;
  VendorTAXNo?: string | null;
  CurrencyID?: number | null;
  CurrencyRate?: number | null;
  BillAmountWOTaxInDefaultCurr?: number | null;
  BillDiscountInDefaultCurr?: number | null;
  BillTaxInDefaultCurr?: number | null;
  BillTotalAmountInDefaultCurr?: number | null;
  StockDetailList?: StockDetailViewModel[] | null;
  IsDefaultCurrency?: boolean;
  DefaultCurrencyCode?: string | null;
  CurrencyCode?: string | null;
}

export interface BranchData {
  UnitTypeID?: number;
  TypeTitle?: string | null;
  TypeTitleEn?: string | null;
  CompanyID?: number;
  Title?: string | null;
  TitleEn?: string | null;
  UnitApplicationTypeTitle?: string | null;
  DESCRIPTION?: string | null;
  TypeCode?: string | null;
  PARENT?: number | null;
  Code?: string | null;
  UnitApplicationTypeID?: number;
  CityID?: number;
  DistID?: number | null;
  Address?: string | null;
  ID?: number;
  IS_ACTIVE?: boolean;
  NOTES?: string | null;
  ParentPath?: string | null;
  CityName?: string | null;
  HasChildren?: boolean;
  Items?: BranchData[] | null;
  EmployeeCount?: number;
  ChildernCount?: number;
}

export interface CityData {
  CountryID?: number;
  CityID?: number;
  Name?: string | null;
  NameEn?: string | null;
  DisplayTitle?: string | null;
  Code?: string | null;
  CountryCode?: string | null;
}

export interface CountryData {
  CountryID?: number;
  Code?: string | null;
  Title?: string | null;
  Nationality?: string | null;
  PhoneKey?: string | null;
  DisplayOrder?: number;
  TitleEnglish?: string | null;
  NationalityEnglish?: string | null;
  DisplayTitle?: string | null;
  DisplayNatTitle?: string | null;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
